
import React from "react";

const svg = {
  notificationIcon: (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="45"
        height="45"
        rx="22.5"
        fill="#D2D2D2"
        fill-opacity="0.2"
      />
      <path
        d="M27.3623 20.3311H27.8981V20.331L27.3623 20.3311ZM28.751 24.9678L29.2868 24.9678V24.9678H28.751ZM26.7432 27.2871L26.8117 27.8185L26.8117 27.8185L26.7432 27.2871ZM22.499 27.6289L22.499 28.1647H22.499V27.6289ZM18.2559 27.2871L18.1873 27.8185H18.1873L18.2559 27.2871ZM16.248 24.9678H15.7122V24.9678L16.248 24.9678ZM17.6377 20.3311L17.1019 20.331V20.3311H17.6377ZM28.3341 23.6189L27.892 23.9216L28.3341 23.6189ZM22.6504 15.6201V16.1559C24.9565 16.1559 26.8263 18.0252 26.8265 20.3311L27.3623 20.3311L27.8981 20.331C27.8979 17.4331 25.5481 15.0843 22.6504 15.0843V15.6201ZM27.3623 20.3311H26.8265V21.5072H27.3623H27.8981V20.3311H27.3623ZM28.3341 23.6189L27.892 23.9216C28.0959 24.2193 28.2152 24.5787 28.2152 24.9678H28.751H29.2868C29.2868 24.3556 29.0982 23.7862 28.7762 23.3161L28.3341 23.6189ZM28.751 24.9678L28.2152 24.9677C28.2151 25.8795 27.5583 26.6417 26.6746 26.7557L26.7432 27.2871L26.8117 27.8185C28.2503 27.6329 29.2866 26.3975 29.2868 24.9678L28.751 24.9678ZM26.7432 27.2871L26.6746 26.7557C25.3917 26.9212 23.7557 27.0931 22.499 27.0931V27.6289V28.1647C23.8288 28.1647 25.5223 27.9848 26.8117 27.8185L26.7432 27.2871ZM22.499 27.6289L22.499 27.0931C21.2424 27.0931 19.6072 26.9212 18.3244 26.7557L18.2559 27.2871L18.1873 27.8185C19.4766 27.9848 21.1693 28.1647 22.499 28.1647L22.499 27.6289ZM18.2559 27.2871L18.3244 26.7557C17.4407 26.6417 16.784 25.8795 16.7839 24.9677L16.248 24.9678L15.7122 24.9678C15.7124 26.3975 16.7487 27.6329 18.1873 27.8185L18.2559 27.2871ZM16.248 24.9678H16.7839C16.7839 24.5786 16.9031 24.2193 17.1071 23.9218L16.6651 23.6189L16.2231 23.316C15.9009 23.7861 15.7122 24.3554 15.7122 24.9678H16.248ZM17.6377 21.5066H18.1735V20.3311H17.6377H17.1019V21.5066H17.6377ZM17.6377 20.3311L18.1735 20.3311C18.1737 18.0252 20.0435 16.1559 22.3496 16.1559V15.6201V15.0843C19.4519 15.0843 17.1021 17.4331 17.1019 20.331L17.6377 20.3311ZM22.3496 15.6201V16.1559H22.6504V15.6201V15.0843H22.3496V15.6201ZM16.6651 23.6189L17.1071 23.9218C17.3153 23.6179 17.5845 23.2501 17.7899 22.8682C18.0001 22.4776 18.1735 22.0218 18.1735 21.5066H17.6377H17.1019C17.1019 21.7776 17.0113 22.0537 16.8462 22.3605C16.6765 22.676 16.4593 22.9713 16.2231 23.316L16.6651 23.6189ZM27.3623 21.5072H26.8265C26.8265 22.0222 26.9998 22.4778 27.2097 22.8683C27.415 23.2501 27.684 23.6178 27.892 23.9216L28.3341 23.6189L28.7762 23.3161C28.5401 22.9715 28.3232 22.6763 28.1536 22.3609C27.9887 22.0541 27.8981 21.7781 27.8981 21.5072H27.3623Z"
        fill="white"
      />
      <path
        d="M24.2344 29.3086C23.8611 29.8195 23.2227 30.1562 22.4979 30.1562C21.7731 30.1562 21.1347 29.8195 20.7614 29.3086"
        stroke="white"
        stroke-width="1.25"
        stroke-linecap="round"
      />
      <circle
        cx="25.875"
        cy="17.125"
        r="4"
        fill="white"
        stroke="white"
        stroke-width="1.25"
      />
    </svg>
  ),
  settingssIcon: (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="45"
        height="45"
        rx="22.5"
        fill="#D2D2D2"
        fill-opacity="0.2"
      />
      <g clip-path="url(#clip0_485_2481)">
        <path
          d="M21.6406 14.6816C22.1405 14.2728 22.8595 14.2728 23.3594 14.6816C23.4534 14.7586 23.5647 14.8898 23.9043 15.3076C24.0451 15.4808 24.1454 15.6067 24.2568 15.7158C24.7375 16.1868 25.3818 16.453 26.0547 16.46C26.2107 16.4616 26.3707 16.4448 26.5928 16.4219C27.1287 16.3665 27.3 16.3521 27.4209 16.3643C28.0634 16.4286 28.5714 16.9366 28.6357 17.5791C28.6479 17.7 28.6335 17.8713 28.5781 18.4072C28.5552 18.6293 28.5384 18.7893 28.54 18.9453C28.547 19.6182 28.8132 20.2625 29.2842 20.7432C29.3933 20.8546 29.5192 20.9549 29.6924 21.0957C30.1102 21.4353 30.2414 21.5466 30.3184 21.6406C30.7272 22.1405 30.7272 22.8595 30.3184 23.3594C30.2414 23.4534 30.1102 23.5647 29.6924 23.9043C29.5192 24.0451 29.3933 24.1454 29.2842 24.2568C28.8132 24.7375 28.547 25.3818 28.54 26.0547C28.5384 26.2107 28.5552 26.3707 28.5781 26.5928C28.6335 27.1287 28.6479 27.3 28.6357 27.4209C28.5714 28.0634 28.0634 28.5714 27.4209 28.6357C27.3 28.6479 27.1287 28.6335 26.5928 28.5781C26.3707 28.5552 26.2107 28.5384 26.0547 28.54C25.3818 28.547 24.7375 28.8132 24.2568 29.2842C24.1454 29.3933 24.0451 29.5192 23.9043 29.6924C23.5647 30.1102 23.4534 30.2414 23.3594 30.3184C22.8595 30.7272 22.1405 30.7272 21.6406 30.3184C21.5466 30.2414 21.4353 30.1102 21.0957 29.6924C20.9549 29.5192 20.8546 29.3933 20.7432 29.2842C20.2625 28.8132 19.6182 28.547 18.9453 28.54C18.7893 28.5384 18.6293 28.5552 18.4072 28.5781C17.8713 28.6335 17.7 28.6479 17.5791 28.6357C16.9366 28.5714 16.4286 28.0634 16.3643 27.4209C16.3521 27.3 16.3665 27.1287 16.4219 26.5928C16.4448 26.3707 16.4616 26.2107 16.46 26.0547C16.453 25.3818 16.1868 24.7375 15.7158 24.2568C15.6067 24.1454 15.4808 24.0451 15.3076 23.9043C14.8898 23.5647 14.7586 23.4534 14.6816 23.3594C14.2728 22.8595 14.2728 22.1405 14.6816 21.6406C14.7586 21.5466 14.8898 21.4353 15.3076 21.0957C15.4808 20.9549 15.6067 20.8546 15.7158 20.7432C16.1868 20.2625 16.453 19.6182 16.46 18.9453C16.4616 18.7893 16.4448 18.6293 16.4219 18.4072C16.3665 17.8713 16.3521 17.7 16.3643 17.5791C16.4286 16.9366 16.9366 16.4286 17.5791 16.3643C17.7 16.3521 17.8713 16.3665 18.4072 16.4219C18.6293 16.4448 18.7893 16.4616 18.9453 16.46C19.6182 16.453 20.2625 16.1868 20.7432 15.7158C20.8546 15.6067 20.9549 15.4808 21.0957 15.3076C21.4353 14.8898 21.5466 14.7586 21.6406 14.6816Z"
          stroke="white"
          stroke-width="1.25"
        />
        <rect
          x="19.625"
          y="19.625"
          width="5.75"
          height="5.75"
          rx="2"
          stroke="white"
          stroke-width="1.25"
        />
      </g>
      <defs>
        <clipPath id="clip0_485_2481">
          <rect
            width="17.5"
            height="17.5"
            fill="white"
            transform="translate(13.75 13.75)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  filterIcon: (
    <svg
      width="22"
      height="12"
      viewBox="0 0 22 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.75 6C17.75 6.19891 17.671 6.38968 17.5303 6.53033C17.3897 6.67098 17.1989 6.75 17 6.75H5C4.80109 6.75 4.61032 6.67098 4.46967 6.53033C4.32902 6.38968 4.25 6.19891 4.25 6C4.25 5.80109 4.32902 5.61032 4.46967 5.46967C4.61032 5.32902 4.80109 5.25 5 5.25H17C17.1989 5.25 17.3897 5.32902 17.5303 5.46967C17.671 5.61032 17.75 5.80109 17.75 6ZM20.75 0.75H1.25C1.05109 0.75 0.860322 0.829018 0.71967 0.96967C0.579018 1.11032 0.5 1.30109 0.5 1.5C0.5 1.69891 0.579018 1.88968 0.71967 2.03033C0.860322 2.17098 1.05109 2.25 1.25 2.25H20.75C20.9489 2.25 21.1397 2.17098 21.2803 2.03033C21.421 1.88968 21.5 1.69891 21.5 1.5C21.5 1.30109 21.421 1.11032 21.2803 0.96967C21.1397 0.829018 20.9489 0.75 20.75 0.75ZM13.25 9.75H8.75C8.55109 9.75 8.36032 9.82902 8.21967 9.96967C8.07902 10.1103 8 10.3011 8 10.5C8 10.6989 8.07902 10.8897 8.21967 11.0303C8.36032 11.171 8.55109 11.25 8.75 11.25H13.25C13.4489 11.25 13.6397 11.171 13.7803 11.0303C13.921 10.8897 14 10.6989 14 10.5C14 10.3011 13.921 10.1103 13.7803 9.96967C13.6397 9.82902 13.4489 9.75 13.25 9.75Z"
        fill="black"
      />
    </svg>
  ),
  plusIcon: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.42773 6.00014H5.99916M5.99916 6.00014H10.5706M5.99916 6.00014V1.42871M5.99916 6.00014V10.5716"
        stroke="white"
        stroke-width="1.14286"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  downArrow: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M3 5L6 8L9 5"
        stroke="#101010"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  TrashIcon: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6109 3.3335H1.38867M13.3143 5.27794L12.9566 10.6446C12.8189 12.7088 12.7504 13.7409 12.0777 14.3702C11.4049 14.9994 10.3697 15.0002 8.30078 15.0002H7.69878C5.62989 15.0002 4.59467 15.0002 3.92189 14.3702C3.24912 13.7409 3.17989 12.7088 3.04301 10.6446L2.68523 5.27794M6.05534 7.22238L6.44423 11.1113M9.94423 7.22238L9.55534 11.1113"
        stroke="#EE3722"
        stroke-width="1.06667"
        stroke-linecap="round"
      />
      <path
        d="M3.72266 3.33333H3.80821C4.12123 3.32534 4.42454 3.22306 4.67849 3.03989C4.93243 2.85671 5.12519 2.60117 5.23154 2.30667L5.25799 2.22656L5.33343 2.00022C5.39799 1.80656 5.43066 1.71011 5.47343 1.62767C5.5576 1.46619 5.67839 1.32666 5.82614 1.22023C5.97389 1.11381 6.1445 1.04345 6.32432 1.01478C6.41532 1 6.51721 1 6.72099 1H9.27988C9.48366 1 9.58554 1 9.67654 1.01478C9.85636 1.04345 10.027 1.11381 10.1747 1.22023C10.3225 1.32666 10.4433 1.46619 10.5274 1.62767C10.5702 1.71011 10.6029 1.80656 10.6674 2.00022L10.7429 2.22656C10.8414 2.55421 11.0453 2.84023 11.3229 3.04031C11.6004 3.2404 11.9362 3.34339 12.2782 3.33333"
        stroke="#EE3722"
        stroke-width="1.06667"
      />
    </svg>
  ),
  settingsIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M6.3125 0.745117C6.71237 0.418073 7.28763 0.418073 7.6875 0.745117C7.76272 0.806646 7.85139 0.911867 8.12305 1.24609C8.23555 1.38451 8.31626 1.48501 8.40527 1.57227C8.78981 1.94903 9.30544 2.16243 9.84375 2.16797C9.96852 2.16924 10.0968 2.15604 10.2744 2.1377C10.7026 2.09348 10.8398 2.08118 10.9365 2.09082C11.4505 2.14231 11.8577 2.54947 11.9092 3.06348C11.9188 3.16017 11.9065 3.29738 11.8623 3.72559C11.844 3.90321 11.8308 4.03148 11.832 4.15625C11.8376 4.69456 12.051 5.21019 12.4277 5.59473C12.515 5.68374 12.6155 5.76445 12.7539 5.87695C13.0881 6.14861 13.1934 6.23728 13.2549 6.3125C13.5819 6.71237 13.5819 7.28763 13.2549 7.6875C13.1934 7.76272 13.0881 7.85139 12.7539 8.12305C12.6155 8.23555 12.515 8.31626 12.4277 8.40527C12.051 8.78981 11.8376 9.30544 11.832 9.84375C11.8308 9.96852 11.844 10.0968 11.8623 10.2744C11.9065 10.7026 11.9188 10.8398 11.9092 10.9365C11.8577 11.4505 11.4505 11.8577 10.9365 11.9092C10.8398 11.9188 10.7026 11.9065 10.2744 11.8623C10.0968 11.844 9.96852 11.8308 9.84375 11.832C9.30544 11.8376 8.78981 12.051 8.40527 12.4277C8.31626 12.515 8.23555 12.6155 8.12305 12.7539C7.85139 13.0881 7.76272 13.1934 7.6875 13.2549C7.28763 13.5819 6.71237 13.5819 6.3125 13.2549C6.23728 13.1934 6.14862 13.0881 5.87695 12.7539C5.76445 12.6155 5.68374 12.515 5.59473 12.4277C5.21019 12.051 4.69456 11.8376 4.15625 11.832C4.03148 11.8308 3.90321 11.844 3.72559 11.8623C3.29738 11.9065 3.16017 11.9188 3.06348 11.9092C2.54947 11.8577 2.14231 11.4505 2.09082 10.9365C2.08118 10.8398 2.09348 10.7026 2.1377 10.2744C2.15604 10.0968 2.16924 9.96852 2.16797 9.84375C2.16243 9.30544 1.94903 8.78981 1.57227 8.40527C1.48501 8.31626 1.38451 8.23555 1.24609 8.12305C0.911867 7.85139 0.806646 7.76272 0.745117 7.6875C0.418073 7.28763 0.418073 6.71237 0.745117 6.3125C0.806647 6.23728 0.911869 6.14861 1.24609 5.87695C1.38451 5.76445 1.48501 5.68374 1.57227 5.59473C1.94903 5.21019 2.16243 4.69456 2.16797 4.15625C2.16924 4.03148 2.15604 3.90321 2.1377 3.72559C2.09348 3.29738 2.08118 3.16017 2.09082 3.06348C2.14231 2.54947 2.54947 2.14231 3.06348 2.09082C3.16017 2.08118 3.29738 2.09348 3.72559 2.1377C3.90321 2.15604 4.03148 2.16924 4.15625 2.16797C4.69456 2.16243 5.21019 1.94903 5.59473 1.57227C5.68374 1.48501 5.76445 1.38451 5.87695 1.24609C6.14861 0.911869 6.23728 0.806647 6.3125 0.745117Z"
        stroke="#041D37"
      />
      <rect
        x="4.69983"
        y="4.69983"
        width="4.6"
        height="4.6"
        rx="1.6"
        stroke="#041D37"
      />
    </svg>
  ),
  editIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
    >
      <path
        d="M8.08334 2.33332L12.1667 6.41666M8.70984 2.26624C9.14442 1.79549 9.36142 1.56041 9.59242 1.42274C9.86512 1.25951 10.176 1.17104 10.4938 1.16622C10.8116 1.16141 11.125 1.24043 11.4025 1.39532C11.6376 1.52599 11.8616 1.75466 12.3096 2.21199C12.7576 2.66991 12.9816 2.89916 13.1088 3.13891C13.2605 3.42439 13.3376 3.74359 13.3331 4.06686C13.3285 4.39013 13.2423 4.70701 13.0825 4.98807C12.9483 5.22374 12.7179 5.44599 12.2565 5.88991L6.77142 11.1732C5.89759 12.0149 5.46067 12.4355 4.91467 12.649C4.36867 12.8625 3.76842 12.8462 2.56792 12.8152L2.40459 12.8106C2.03942 12.8012 1.85626 12.7966 1.75067 12.6758C1.64392 12.5551 1.65851 12.369 1.68767 11.9968L1.70342 11.795C1.78509 10.7473 1.82592 10.2235 2.03009 9.75216C2.23426 9.28082 2.58776 8.89874 3.29359 8.13399L8.70984 2.26624Z"
        stroke="#101010"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  deleteIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
    >
      <path
        d="M5.25415 3.83216L5.25415 2.85063C5.25415 2.16663 5.25415 1.82464 5.45934 1.61215C5.66452 1.39966 5.99476 1.39966 6.65524 1.39966L8.55084 1.39966C9.21132 1.39966 9.54156 1.39966 9.74674 1.61215C9.95193 1.82464 9.95193 2.16663 9.95193 2.85063V3.83216"
        stroke="#EE3722"
      />
      <path
        d="M8.77954 6.81079V9.7469"
        stroke="#EE3722"
        stroke-linecap="round"
      />
      <path
        d="M6.42993 6.81079V9.7469"
        stroke="#EE3722"
        stroke-linecap="round"
      />
      <path
        d="M7.56958 12.7991C6.89103 12.7991 6.41346 12.7983 6.04028 12.7659C5.67484 12.734 5.45276 12.6746 5.27661 12.5803C5.0122 12.4387 4.78645 12.2341 4.61841 11.9856C4.50639 11.82 4.42397 11.6051 4.35474 11.2444C4.28417 10.8766 4.23392 10.4025 4.16431 9.72778L3.57349 3.99927L11.5657 3.99927L10.9739 9.72778C10.9043 10.4024 10.855 10.8766 10.7844 11.2444C10.7152 11.605 10.6327 11.82 10.5208 11.9856C10.3527 12.2341 10.127 12.4387 9.86255 12.5803C9.68628 12.6747 9.46382 12.734 9.0979 12.7659C8.72478 12.7983 8.24795 12.7991 7.56958 12.7991Z"
        stroke="#EE3722"
      />
      <path
        d="M2.3186 3.81958H12.8886"
        stroke="#EE3722"
        stroke-linecap="round"
      />
    </svg>
  ),
  deleteIconWhite: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
    >
      <path
        d="M3.75415 3.83216L3.75415 2.85063C3.75415 2.16663 3.75415 1.82464 3.95934 1.61215C4.16452 1.39966 4.49476 1.39966 5.15524 1.39966L7.05084 1.39966C7.71132 1.39966 8.04156 1.39966 8.24674 1.61215C8.45193 1.82464 8.45193 2.16663 8.45193 2.85063V3.83216"
        stroke="white"
      />
      <path d="M7.27954 6.81079V9.7469" stroke="white" stroke-linecap="round" />
      <path d="M4.92993 6.81079V9.7469" stroke="white" stroke-linecap="round" />
      <path
        d="M6.06958 12.7991C5.39103 12.7991 4.91346 12.7983 4.54028 12.7659C4.17484 12.734 3.95276 12.6746 3.77661 12.5803C3.5122 12.4387 3.28645 12.2341 3.11841 11.9856C3.00639 11.82 2.92397 11.6051 2.85474 11.2444C2.78417 10.8766 2.73392 10.4025 2.66431 9.72778L2.07349 3.99927L10.0657 3.99927L9.47388 9.72778C9.40427 10.4024 9.35498 10.8766 9.28442 11.2444C9.21522 11.605 9.1327 11.82 9.02075 11.9856C8.85271 12.2341 8.62696 12.4387 8.36255 12.5803C8.18628 12.6747 7.96382 12.734 7.5979 12.7659C7.22478 12.7983 6.74795 12.7991 6.06958 12.7991Z"
        stroke="white"
      />
      <path
        d="M0.818604 3.81958H11.3886"
        stroke="white"
        stroke-linecap="round"
      />
    </svg>
  ),
  deleteAllIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M10.9582 2.5H1.0415M9.98575 3.95833L9.71742 7.98333C9.61417 9.5315 9.56284 10.3056 9.05825 10.7775C8.55367 11.2494 7.77725 11.25 6.22559 11.25H5.77409C4.22242 11.25 3.446 11.25 2.94142 10.7775C2.43684 10.3056 2.38492 9.5315 2.28225 7.98333L2.01392 3.95833M4.5415 5.41667L4.83317 8.33333M7.45817 5.41667L7.1665 8.33333"
        stroke="#878787"
        stroke-width="0.8"
        stroke-linecap="round"
      />
      <path
        d="M2.7915 2.5H2.85567C3.09043 2.494 3.31792 2.4173 3.50838 2.27992C3.69884 2.14253 3.8434 1.95087 3.92317 1.73L3.943 1.66992L3.99959 1.50017C4.048 1.35492 4.0725 1.28258 4.10459 1.22075C4.16771 1.09964 4.2583 0.994995 4.36912 0.915176C4.47993 0.835357 4.60789 0.782585 4.74275 0.761083C4.811 0.75 4.88742 0.75 5.04025 0.75H6.95942C7.11225 0.75 7.18867 0.75 7.25692 0.761083C7.39179 0.782585 7.51974 0.835357 7.63056 0.915176C7.74137 0.994995 7.83197 1.09964 7.89509 1.22075C7.92717 1.28258 7.95167 1.35492 8.00009 1.50017L8.05667 1.66992C8.13059 1.91566 8.28348 2.13017 8.49165 2.28024C8.69982 2.4303 8.95166 2.50754 9.20817 2.5"
        stroke="#878787"
        stroke-width="0.8"
      />
    </svg>
  ),
  calendarIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M1.16785 6.99552C1.16785 4.79577 1.16785 3.69561 1.85151 3.01252C2.53518 2.32944 3.63476 2.32886 5.83451 2.32886H8.16785C10.3676 2.32886 11.4678 2.32886 12.1508 3.01252C12.8339 3.69619 12.8345 4.79577 12.8345 6.99552V8.16219C12.8345 10.3619 12.8345 11.4621 12.1508 12.1452C11.4672 12.8283 10.3676 12.8289 8.16785 12.8289H5.83451C3.63476 12.8289 2.5346 12.8289 1.85151 12.1452C1.16843 11.4615 1.16785 10.3619 1.16785 8.16219V6.99552Z"
        stroke="#041D37"
      />
      <path
        d="M4.08337 2.32886V1.45386M9.91671 2.32886V1.45386M1.45837 5.24552H12.5417"
        stroke="#041D37"
        stroke-linecap="round"
      />
      <path
        d="M10.5023 9.91105C10.5023 10.0658 10.4409 10.2141 10.3315 10.3235C10.2221 10.4329 10.0737 10.4944 9.91899 10.4944C9.76428 10.4944 9.6159 10.4329 9.50651 10.3235C9.39711 10.2141 9.33565 10.0658 9.33565 9.91105C9.33565 9.75634 9.39711 9.60797 9.50651 9.49857C9.6159 9.38918 9.76428 9.32772 9.91899 9.32772C10.0737 9.32772 10.2221 9.38918 10.3315 9.49857C10.4409 9.60797 10.5023 9.75634 10.5023 9.91105ZM10.5023 7.57772C10.5023 7.73243 10.4409 7.8808 10.3315 7.9902C10.2221 8.09959 10.0737 8.16105 9.91899 8.16105C9.76428 8.16105 9.6159 8.09959 9.50651 7.9902C9.39711 7.8808 9.33565 7.73243 9.33565 7.57772C9.33565 7.42301 9.39711 7.27464 9.50651 7.16524C9.6159 7.05584 9.76428 6.99438 9.91899 6.99438C10.0737 6.99438 10.2221 7.05584 10.3315 7.16524C10.4409 7.27464 10.5023 7.42301 10.5023 7.57772ZM7.58565 9.91105C7.58565 10.0658 7.52419 10.2141 7.4148 10.3235C7.3054 10.4329 7.15703 10.4944 7.00232 10.4944C6.84761 10.4944 6.69924 10.4329 6.58984 10.3235C6.48044 10.2141 6.41899 10.0658 6.41899 9.91105C6.41899 9.75634 6.48044 9.60797 6.58984 9.49857C6.69924 9.38918 6.84761 9.32772 7.00232 9.32772C7.15703 9.32772 7.3054 9.38918 7.4148 9.49857C7.52419 9.60797 7.58565 9.75634 7.58565 9.91105ZM7.58565 7.57772C7.58565 7.73243 7.52419 7.8808 7.4148 7.9902C7.3054 8.09959 7.15703 8.16105 7.00232 8.16105C6.84761 8.16105 6.69924 8.09959 6.58984 7.9902C6.48044 7.8808 6.41899 7.73243 6.41899 7.57772C6.41899 7.42301 6.48044 7.27464 6.58984 7.16524C6.69924 7.05584 6.84761 6.99438 7.00232 6.99438C7.15703 6.99438 7.3054 7.05584 7.4148 7.16524C7.52419 7.27464 7.58565 7.42301 7.58565 7.57772ZM4.66899 9.91105C4.66899 10.0658 4.60753 10.2141 4.49813 10.3235C4.38874 10.4329 4.24036 10.4944 4.08565 10.4944C3.93094 10.4944 3.78257 10.4329 3.67317 10.3235C3.56378 10.2141 3.50232 10.0658 3.50232 9.91105C3.50232 9.75634 3.56378 9.60797 3.67317 9.49857C3.78257 9.38918 3.93094 9.32772 4.08565 9.32772C4.24036 9.32772 4.38874 9.38918 4.49813 9.49857C4.60753 9.60797 4.66899 9.75634 4.66899 9.91105ZM4.66899 7.57772C4.66899 7.73243 4.60753 7.8808 4.49813 7.9902C4.38874 8.09959 4.24036 8.16105 4.08565 8.16105C3.93094 8.16105 3.78257 8.09959 3.67317 7.9902C3.56378 7.8808 3.50232 7.73243 3.50232 7.57772C3.50232 7.42301 3.56378 7.27464 3.67317 7.16524C3.78257 7.05584 3.93094 6.99438 4.08565 6.99438C4.24036 6.99438 4.38874 7.05584 4.49813 7.16524C4.60753 7.27464 4.66899 7.42301 4.66899 7.57772Z"
        fill="#041D37"
      />
    </svg>
  ),
  VectorIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="11"
      viewBox="0 0 14 11"
      fill="none"
    >
      <path
        d="M7.5 11V8H8.85949C9.11384 8 9.25279 7.70334 9.08995 7.50794L7 5L4.91005 7.50795C4.74721 7.70334 4.88616 8 5.14051 8H6.5V11H4V10.975C3.916 10.98 3.836 11 3.75 11C2.75544 11 1.80161 10.6049 1.09835 9.90165C0.395088 9.19839 0 8.24456 0 7.25C0 5.326 1.455 3.758 3.322 3.543C3.48569 2.6873 3.94245 1.91538 4.61371 1.36001C5.28497 0.804638 6.12878 0.500534 7 0.5C7.87134 0.500482 8.71529 0.804545 9.38672 1.3599C10.0582 1.91526 10.5151 2.68721 10.679 3.543C12.546 3.758 13.999 5.326 13.999 7.25C13.999 8.24456 13.6039 9.19839 12.9007 9.90165C12.1974 10.6049 11.2436 11 10.249 11C10.165 11 10.084 10.98 9.999 10.975V11H7.5Z"
        fill="#969696"
      />
    </svg>
  ),
  VectorsIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="19"
      viewBox="0 0 22 19"
      fill="none"
    >
      <path
        d="M11.0406 6.93165V18.5M11.0406 6.93165L14.7754 10.7878M11.0406 6.93165L7.3058 10.7878M17.8877 13.3585C19.7787 13.3585 21 11.7762 21 9.82374C20.9999 9.05074 20.7545 8.29907 20.3012 7.68386C19.8479 7.06865 19.2117 6.62382 18.4902 6.4175C18.3792 4.9759 17.8005 3.61509 16.8478 2.55508C15.895 1.49506 14.6238 0.797806 13.2398 0.576032C11.8557 0.354259 10.4396 0.620933 9.22049 1.33294C8.00137 2.04495 7.05046 3.16067 6.5215 4.49973C5.40782 4.18098 4.21712 4.33207 3.21133 4.91976C2.20555 5.50745 1.46707 6.4836 1.15836 7.63346C0.849643 8.78333 0.995981 10.0127 1.56518 11.0512C2.13438 12.0896 3.07981 12.8521 4.19349 13.1708"
        stroke="#101010"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  addIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M3 7H7M7 7H11M7 7V3M7 7V11"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  addIconBlack: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M8.37891 3.5V12.5M12.8789 8H3.87891"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  cancelIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M2.75781 13.2431L8.00081 8.00008L13.2438 13.2431M13.2438 2.75708L7.99981 8.00008L2.75781 2.75708"
        stroke="#101010"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  PeopleIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
    >
      <path
        d="M4.42878 0.857117C4.0911 0.857117 3.75672 0.923629 3.44474 1.05286C3.13276 1.18208 2.84929 1.37149 2.61051 1.61027C2.37173 1.84905 2.18232 2.13252 2.05309 2.4445C1.92386 2.75648 1.85735 3.09086 1.85735 3.42854C1.85735 3.76623 1.92386 4.10061 2.05309 4.41259C2.18232 4.72457 2.37173 5.00804 2.61051 5.24682C2.84929 5.4856 3.13276 5.67501 3.44474 5.80424C3.75672 5.93346 4.0911 5.99997 4.42878 5.99997C5.11077 5.99997 5.76482 5.72906 6.24706 5.24682C6.72929 4.76458 7.00021 4.11053 7.00021 3.42854C7.00021 2.74656 6.72929 2.09251 6.24706 1.61027C5.76482 1.12803 5.11077 0.857117 4.42878 0.857117ZM2.7145 3.42854C2.7145 3.20342 2.75884 2.9805 2.84499 2.77252C2.93114 2.56453 3.05741 2.37555 3.2166 2.21636C3.37578 2.05718 3.56477 1.9309 3.77275 1.84475C3.98074 1.7586 4.20366 1.71426 4.42878 1.71426C4.6539 1.71426 4.87682 1.7586 5.08481 1.84475C5.2928 1.9309 5.48178 2.05718 5.64096 2.21636C5.80015 2.37555 5.92642 2.56453 6.01257 2.77252C6.09873 2.9805 6.14307 3.20342 6.14307 3.42854C6.14307 3.8832 5.96246 4.31924 5.64096 4.64073C5.31947 4.96222 4.88344 5.14283 4.42878 5.14283C3.97412 5.14283 3.53809 4.96222 3.2166 4.64073C2.89511 4.31924 2.7145 3.8832 2.7145 3.42854ZM10.4288 1.99997C9.89835 1.99997 9.38964 2.21069 9.01457 2.58576C8.63949 2.96083 8.42878 3.46954 8.42878 3.99997C8.42878 4.53041 8.63949 5.03911 9.01457 5.41419C9.38964 5.78926 9.89835 5.99997 10.4288 5.99997C10.9592 5.99997 11.4679 5.78926 11.843 5.41419C12.2181 5.03911 12.4288 4.53041 12.4288 3.99997C12.4288 3.46954 12.2181 2.96083 11.843 2.58576C11.4679 2.21069 10.9592 1.99997 10.4288 1.99997ZM9.28592 3.99997C9.28592 3.69687 9.40633 3.40618 9.62066 3.19185C9.83499 2.97752 10.1257 2.85712 10.4288 2.85712C10.7319 2.85712 11.0226 2.97752 11.2369 3.19185C11.4512 3.40618 11.5716 3.69687 11.5716 3.99997C11.5716 4.30308 11.4512 4.59377 11.2369 4.8081C11.0226 5.02242 10.7319 5.14283 10.4288 5.14283C10.1257 5.14283 9.83499 5.02242 9.62066 4.8081C9.40633 4.59377 9.28592 4.30308 9.28592 3.99997ZM0.143066 8.42854C0.143066 8.08755 0.278525 7.76053 0.519643 7.51941C0.760762 7.27829 1.08779 7.14283 1.42878 7.14283H7.42878C7.76977 7.14283 8.0968 7.27829 8.33792 7.51941C8.57904 7.76053 8.7145 8.08755 8.7145 8.42854V8.73197C8.71406 8.77822 8.71081 8.8244 8.70478 8.87026C8.69192 8.98814 8.67091 9.10499 8.64192 9.21997C8.54727 9.59515 8.37885 9.94772 8.1465 10.2571C7.56707 11.0303 6.46192 11.7143 4.42878 11.7143C2.39564 11.7143 1.2905 11.0303 0.711066 10.2571C0.478913 9.94767 0.310691 9.59511 0.216209 9.21997C0.178812 9.07061 0.154907 8.91819 0.144781 8.76454L0.143066 8.73197V8.42854ZM1.00021 8.7114V8.72169L1.00535 8.77883C1.01107 8.83255 1.02249 8.91312 1.04764 9.01197C1.11426 9.27628 1.23275 9.52471 1.39621 9.74283C1.78135 10.2554 2.60478 10.8571 4.42878 10.8571C6.25278 10.8571 7.07621 10.2554 7.46078 9.74283C7.66078 9.47654 7.76021 9.21026 7.80935 9.01197C7.83345 8.91675 7.84932 8.81963 7.85678 8.72169L7.85735 8.7114V8.42854C7.85735 8.31488 7.8122 8.20587 7.73183 8.1255C7.65145 8.04513 7.54245 7.99997 7.42878 7.99997H1.42878C1.31512 7.99997 1.20611 8.04513 1.12573 8.1255C1.04536 8.20587 1.00021 8.31488 1.00021 8.42854V8.7114ZM8.77164 10.3543C9.21335 10.4897 9.7585 10.5714 10.4276 10.5714C12.0105 10.5714 12.8951 10.1165 13.3756 9.56797C13.5675 9.35069 13.7098 9.09429 13.7928 8.81655C13.8252 8.7043 13.8461 8.58903 13.8551 8.47254L13.8562 8.44569V8.42854C13.8562 8.08755 13.7208 7.76053 13.4796 7.51941C13.2385 7.27829 12.9115 7.14283 12.5705 7.14283H8.76821C8.99335 7.37769 9.15792 7.67197 9.23564 7.99997H12.5711C12.6837 7.99996 12.7919 8.04433 12.8721 8.12347C12.9523 8.20261 12.9981 8.31016 12.9996 8.42283L12.9968 8.44912C12.9911 8.49221 12.9821 8.53481 12.9699 8.57655C12.9217 8.7345 12.8398 8.88013 12.7299 9.0034C12.4608 9.31197 11.8459 9.71426 10.4276 9.71426C9.88992 9.71426 9.46764 9.65654 9.13564 9.5674C9.04809 9.84403 8.92578 10.1084 8.77164 10.3543Z"
        fill="white"
      />
    </svg>
  ),
  tickIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
    >
      <g clip-path="url(#clip0_2165_6168)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 8C0 6.01088 0.790176 4.10322 2.1967 2.6967C3.60322 1.29018 5.51088 0.5 7.5 0.5C9.48912 0.5 11.3968 1.29018 12.8033 2.6967C14.2098 4.10322 15 6.01088 15 8C15 9.98912 14.2098 11.8968 12.8033 13.3033C11.3968 14.7098 9.48912 15.5 7.5 15.5C5.51088 15.5 3.60322 14.7098 2.1967 13.3033C0.790176 11.8968 0 9.98912 0 8ZM7.072 11.21L11.39 5.812L10.61 5.188L6.928 9.789L4.32 7.616L3.68 8.384L7.072 11.21Z"
          fill="#278D27"
        />
      </g>
      <defs>
        <clipPath id="clip0_2165_6168">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  locationIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8.37319 13.88C8.26439 13.9581 8.13381 14.0002 7.99985 14.0002C7.8659 14.0002 7.73532 13.9581 7.62652 13.88C4.40719 11.5853 0.99052 6.86533 4.44452 3.45467C5.39275 2.5219 6.66974 1.99942 7.99985 2C9.33319 2 10.6125 2.52333 11.5552 3.454C15.0092 6.86467 11.5925 11.584 8.37319 13.88Z"
        stroke="#041D37"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.99999 8.99998C8.53042 8.99998 9.03913 8.78927 9.4142 8.4142C9.78927 8.03913 9.99998 7.53042 9.99998 6.99999C9.99998 6.46956 9.78927 5.96085 9.4142 5.58578C9.03913 5.21071 8.53042 5 7.99999 5C7.46956 5 6.96085 5.21071 6.58578 5.58578C6.21071 5.96085 6 6.46956 6 6.99999C6 7.53042 6.21071 8.03913 6.58578 8.4142C6.96085 8.78927 7.46956 8.99998 7.99999 8.99998Z"
        stroke="#041D37"
        stroke-width="0.999995"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  appIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M9.91683 0.583252H4.0835C3.117 0.583252 2.3335 1.36675 2.3335 2.33325V11.6666C2.3335 12.6331 3.117 13.4166 4.0835 13.4166H9.91683C10.8833 13.4166 11.6668 12.6331 11.6668 11.6666V2.33325C11.6668 1.36675 10.8833 0.583252 9.91683 0.583252Z"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.8335 11.0833H8.16683"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  folderIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clip-path="url(#clip0_3471_885)">
        <path
          d="M10.4997 5.83325H7.58301"
          stroke="#101010"
          stroke-linecap="round"
        />
        <path
          d="M1.1665 4.05413C1.1665 3.53904 1.1665 3.28179 1.20734 3.06713C1.29438 2.6062 1.51833 2.18221 1.84997 1.85047C2.1816 1.51873 2.60552 1.29465 3.06642 1.20746C3.28167 1.16663 3.5395 1.16663 4.054 1.16663C4.27917 1.16663 4.39234 1.16663 4.50084 1.17654C4.96811 1.22043 5.4113 1.40421 5.7725 1.70388C5.8565 1.77329 5.93584 1.85263 6.09567 2.01246L6.4165 2.33329C6.8925 2.80929 7.1305 3.04729 7.41517 3.20538C7.57163 3.29258 7.73761 3.36148 7.90984 3.41071C8.22367 3.49996 8.56025 3.49996 9.23284 3.49996H9.451C10.9863 3.49996 11.7546 3.49996 12.2533 3.94913C12.2996 3.98996 12.3432 4.03351 12.384 4.07979C12.8332 4.57854 12.8332 5.34679 12.8332 6.88213V8.16663C12.8332 10.3664 12.8332 11.4665 12.1495 12.1496C11.4658 12.8327 10.3663 12.8333 8.1665 12.8333H5.83317C3.63342 12.8333 2.53325 12.8333 1.85017 12.1496C1.16709 11.466 1.1665 10.3664 1.1665 8.16663V4.05413Z"
          stroke="#101010"
        />
      </g>
      <defs>
        <clipPath id="clip0_3471_885">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  imageIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M12.39 10.1604C12.4612 9.92359 12.5 9.67188 12.5 9.41176V3.58824C12.5 2.90179 12.2273 2.24346 11.7419 1.75808C11.2565 1.27269 10.5982 1 9.91176 1H4.08824C3.40179 1 2.74346 1.27269 2.25808 1.75808C1.77269 2.24346 1.5 2.90179 1.5 3.58824V9.45706M12.39 10.1604L12.3331 10.0931L10.7374 8.16747C10.6163 8.0214 10.4646 7.90374 10.293 7.82281C10.1214 7.74189 9.93414 7.69969 9.74442 7.69919C9.5547 7.6987 9.36718 7.73993 9.19517 7.81995C9.02315 7.89998 8.87083 8.01686 8.749 8.16229L7.90006 9.17559L7.76159 9.34447M12.39 10.1604C12.233 10.6802 11.9166 11.1368 11.4854 11.4668C11.0543 11.7969 10.5302 11.9829 9.98747 11.9987M1.5 9.45706C1.51188 10.1356 1.7898 10.7824 2.27391 11.258C2.75801 11.7336 3.40957 12.0001 4.08824 12H9.91176L9.98747 11.9987M1.5 9.45706L1.61518 9.32765L3.68965 6.85135C3.81111 6.70639 3.96288 6.58981 4.13425 6.50982C4.30563 6.42983 4.49246 6.38838 4.68159 6.38838C4.87071 6.38838 5.05754 6.42983 5.22892 6.50982C5.4003 6.58981 5.55206 6.70639 5.67353 6.85135L7.76159 9.34447M7.76159 9.34447L9.92729 11.9301L9.98747 11.9987"
        stroke="#969696"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 3.5C9.55228 3.5 10 3.94772 10 4.5C10 5.05228 9.55228 5.5 9 5.5C8.44772 5.5 8 5.05228 8 4.5C8 3.94772 8.44772 3.5 9 3.5Z"
        stroke="#969696"
      />
    </svg>
  ),
  cancelIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M2.75781 13.2431L8.00081 8.00008L13.2438 13.2431M13.2438 2.75708L7.99981 8.00008L2.75781 2.75708"
        stroke="#101010"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  leftArrow: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M8 10L4 6L8 2"
        stroke="#101010"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  instaIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <g clip-path="url(#clip0_3569_3335)">
        <path
          d="M11.006 -0.00195312C6.41364 -0.00195312 5.07053 0.00278633 4.80946 0.0244468C3.86702 0.102807 3.28058 0.251237 2.64168 0.569409C2.14932 0.813977 1.761 1.09746 1.37776 1.49485C0.679821 2.21955 0.256823 3.11113 0.103695 4.17095C0.0292509 4.68546 0.00759022 4.79038 0.0031916 7.41843C0.00150366 8.29444 0.0031916 9.44733 0.0031916 10.9937C0.0031916 15.5837 0.0082637 16.9258 0.0302651 17.1864C0.106405 18.1037 0.250221 18.6808 0.554781 19.3121C1.13683 20.5205 2.24846 21.4277 3.55806 21.7662C4.01152 21.883 4.51235 21.9473 5.1553 21.9777C5.42772 21.9896 8.20426 21.998 10.9825 21.998C13.7608 21.998 16.539 21.9947 16.8046 21.9811C17.5491 21.9461 17.9814 21.888 18.4594 21.7645C19.7775 21.4243 20.8688 20.5307 21.4627 19.3054C21.7613 18.6893 21.9128 18.0902 21.9813 17.2208C21.9962 17.0312 22.0024 14.009 22.0024 10.9909C22.0024 7.97219 21.9957 4.95557 21.9808 4.76601C21.9114 3.88256 21.76 3.28851 21.4517 2.66061C21.1988 2.14661 20.9179 1.76276 20.5101 1.37029C19.7824 0.675026 18.8924 0.251911 17.8319 0.0989157C17.318 0.0246132 17.2156 0.00261179 14.5863 -0.00195312H11.006Z"
          fill="url(#paint0_radial_3569_3335)"
        />
        <path
          d="M11.006 -0.00195312C6.41364 -0.00195312 5.07053 0.00278633 4.80946 0.0244468C3.86702 0.102807 3.28058 0.251237 2.64168 0.569409C2.14932 0.813977 1.761 1.09746 1.37776 1.49485C0.679821 2.21955 0.256823 3.11113 0.103695 4.17095C0.0292509 4.68546 0.00759022 4.79038 0.0031916 7.41843C0.00150366 8.29444 0.0031916 9.44733 0.0031916 10.9937C0.0031916 15.5837 0.0082637 16.9258 0.0302651 17.1864C0.106405 18.1037 0.250221 18.6808 0.554781 19.3121C1.13683 20.5205 2.24846 21.4277 3.55806 21.7662C4.01152 21.883 4.51235 21.9473 5.1553 21.9777C5.42772 21.9896 8.20426 21.998 10.9825 21.998C13.7608 21.998 16.539 21.9947 16.8046 21.9811C17.5491 21.9461 17.9814 21.888 18.4594 21.7645C19.7775 21.4243 20.8688 20.5307 21.4627 19.3054C21.7613 18.6893 21.9128 18.0902 21.9813 17.2208C21.9962 17.0312 22.0024 14.009 22.0024 10.9909C22.0024 7.97219 21.9957 4.95557 21.9808 4.76601C21.9114 3.88256 21.76 3.28851 21.4517 2.66061C21.1988 2.14661 20.9179 1.76276 20.5101 1.37029C19.7824 0.675026 18.8924 0.251911 17.8319 0.0989157C17.318 0.0246132 17.2156 0.00261179 14.5863 -0.00195312H11.006Z"
          fill="url(#paint1_radial_3569_3335)"
        />
        <path
          d="M11.006 -0.00195312C6.41364 -0.00195312 5.07053 0.00278633 4.80946 0.0244468C3.86702 0.102807 3.28058 0.251237 2.64168 0.569409C2.14932 0.813977 1.761 1.09746 1.37776 1.49485C0.679821 2.21955 0.256823 3.11113 0.103695 4.17095C0.0292509 4.68546 0.00759022 4.79038 0.0031916 7.41843C0.00150366 8.29444 0.0031916 9.44733 0.0031916 10.9937C0.0031916 15.5837 0.0082637 16.9258 0.0302651 17.1864C0.106405 18.1037 0.250221 18.6808 0.554781 19.3121C1.13683 20.5205 2.24846 21.4277 3.55806 21.7662C4.01152 21.883 4.51235 21.9473 5.1553 21.9777C5.42772 21.9896 8.20426 21.998 10.9825 21.998C13.7608 21.998 16.539 21.9947 16.8046 21.9811C17.5491 21.9461 17.9814 21.888 18.4594 21.7645C19.7775 21.4243 20.8688 20.5307 21.4627 19.3054C21.7613 18.6893 21.9128 18.0902 21.9813 17.2208C21.9962 17.0312 22.0024 14.009 22.0024 10.9909C22.0024 7.97219 21.9957 4.95557 21.9808 4.76601C21.9114 3.88256 21.76 3.28851 21.4517 2.66061C21.1988 2.14661 20.9179 1.76276 20.5101 1.37029C19.7824 0.675026 18.8924 0.251911 17.8319 0.0989157C17.318 0.0246132 17.2156 0.00261179 14.5863 -0.00195312H11.006Z"
          fill="url(#paint2_radial_3569_3335)"
        />
        <path
          d="M11.006 -0.00195312C6.41364 -0.00195312 5.07053 0.00278633 4.80946 0.0244468C3.86702 0.102807 3.28058 0.251237 2.64168 0.569409C2.14932 0.813977 1.761 1.09746 1.37776 1.49485C0.679821 2.21955 0.256823 3.11113 0.103695 4.17095C0.0292509 4.68546 0.00759022 4.79038 0.0031916 7.41843C0.00150366 8.29444 0.0031916 9.44733 0.0031916 10.9937C0.0031916 15.5837 0.0082637 16.9258 0.0302651 17.1864C0.106405 18.1037 0.250221 18.6808 0.554781 19.3121C1.13683 20.5205 2.24846 21.4277 3.55806 21.7662C4.01152 21.883 4.51235 21.9473 5.1553 21.9777C5.42772 21.9896 8.20426 21.998 10.9825 21.998C13.7608 21.998 16.539 21.9947 16.8046 21.9811C17.5491 21.9461 17.9814 21.888 18.4594 21.7645C19.7775 21.4243 20.8688 20.5307 21.4627 19.3054C21.7613 18.6893 21.9128 18.0902 21.9813 17.2208C21.9962 17.0312 22.0024 14.009 22.0024 10.9909C22.0024 7.97219 21.9957 4.95557 21.9808 4.76601C21.9114 3.88256 21.76 3.28851 21.4517 2.66061C21.1988 2.14661 20.9179 1.76276 20.5101 1.37029C19.7824 0.675026 18.8924 0.251911 17.8319 0.0989157C17.318 0.0246132 17.2156 0.00261179 14.5863 -0.00195312H11.006Z"
          fill="url(#paint3_radial_3569_3335)"
        />
        <path
          d="M11.0042 2.82324C8.78269 2.82324 8.5039 2.83295 7.63138 2.87262C6.76058 2.91247 6.16619 3.05023 5.64609 3.25237C5.1081 3.46113 4.65173 3.7404 4.19708 4.19489C3.74208 4.64922 3.4626 5.10523 3.253 5.64265C3.0502 6.16254 2.91217 6.75666 2.87298 7.62648C2.83396 8.49834 2.82373 8.7771 2.82373 10.9969C2.82373 13.2168 2.83362 13.4945 2.87315 14.3664C2.9132 15.2365 3.05106 15.8305 3.25317 16.3502C3.46226 16.8878 3.74174 17.3438 4.19656 17.7981C4.65106 18.2528 5.10742 18.5327 5.64506 18.7415C6.1655 18.9436 6.76008 19.0814 7.6307 19.1213C8.50322 19.1609 8.78183 19.1706 11.0032 19.1706C13.2248 19.1706 13.5028 19.1609 14.3753 19.1212C15.2461 19.0814 15.8411 18.9436 16.3616 18.7415C16.8994 18.5327 17.3551 18.2528 17.8096 17.7981C18.2646 17.3438 18.544 16.8878 18.7537 16.3504C18.9547 15.8305 19.0928 15.2364 19.1337 14.3665C19.1729 13.4947 19.1831 13.2168 19.1831 10.9969C19.1831 8.77709 19.1729 8.49851 19.1337 7.62665C19.0928 6.75649 18.9547 6.16254 18.7537 5.64283C18.544 5.10523 18.2646 4.64921 17.8096 4.19489C17.3546 3.74022 16.8996 3.46096 16.3611 3.25236C15.8396 3.05023 15.2449 2.91247 14.3741 2.87262C13.5016 2.83295 13.2238 2.82324 11.0016 2.82324H11.0042ZM10.2704 4.29621C10.4882 4.29587 10.7312 4.29621 11.0042 4.29621C13.1882 4.29621 13.447 4.30405 14.3095 4.34321C15.107 4.37965 15.5399 4.51281 15.8282 4.62469C16.2099 4.77283 16.4821 4.94994 16.7682 5.23601C17.0545 5.5221 17.2317 5.79455 17.3803 6.17598C17.4923 6.46377 17.6257 6.89629 17.662 7.69323C17.7012 8.55487 17.7097 8.81371 17.7097 10.9951C17.7097 13.1764 17.7012 13.4353 17.662 14.2969C17.6255 15.0938 17.4923 15.5264 17.3803 15.8141C17.232 16.1956 17.0545 16.4672 16.7682 16.7531C16.4819 17.0392 16.2101 17.2163 15.8282 17.3644C15.5402 17.4768 15.107 17.6096 14.3095 17.6461C13.4472 17.6852 13.1882 17.6937 11.0042 17.6937C8.82001 17.6937 8.56115 17.6852 7.69887 17.6461C6.90135 17.6093 6.4685 17.4761 6.17999 17.3642C5.79827 17.2161 5.5256 17.039 5.23932 16.7529C4.95303 16.4668 4.7758 16.1951 4.6272 15.8135C4.51523 15.5257 4.3818 15.0931 4.34551 14.2962C4.30631 13.4346 4.29847 13.1757 4.29847 10.993C4.29847 8.81031 4.30631 8.55283 4.34551 7.69119C4.38198 6.89425 4.51523 6.46173 4.6272 6.17361C4.77545 5.79217 4.95303 5.51971 5.23932 5.23363C5.5256 4.94755 5.79827 4.77046 6.17999 4.62197C6.46833 4.50957 6.90135 4.37676 7.69887 4.34014C8.45345 4.30608 8.74588 4.29587 10.2704 4.29416L10.2704 4.29621ZM15.3705 5.65338C14.8286 5.65338 14.3889 6.09221 14.3889 6.63388C14.3889 7.17539 14.8286 7.61473 15.3705 7.61473C15.9124 7.61473 16.352 7.17539 16.352 6.63388C16.352 6.09238 15.9124 5.65305 15.3705 5.65305L15.3705 5.65338ZM11.0042 6.7994C8.68436 6.7994 6.80353 8.67884 6.80353 10.9969C6.80353 13.315 8.68436 15.1936 11.0042 15.1936C13.324 15.1936 15.2041 13.315 15.2041 10.9969C15.2041 8.67884 13.3238 6.7994 11.004 6.7994H11.0042ZM11.0042 8.27237C12.5099 8.27237 13.7308 9.49213 13.7308 10.9969C13.7308 12.5016 12.5099 13.7215 11.0042 13.7215C9.49825 13.7215 8.27759 12.5016 8.27759 10.9969C8.27759 9.49213 9.49825 8.27237 11.0042 8.27237Z"
          fill="white"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_3569_3335"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(21.2921 10.3097) rotate(164.25) scale(14.0568 10.1272)"
        >
          <stop stop-color="#FF005F" />
          <stop offset="1" stop-color="#FC01D8" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_3569_3335"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(5.84602 23.6925) rotate(-90) scale(17.5608 18.6317)"
        >
          <stop stop-color="#FFCC00" />
          <stop offset="0.1242" stop-color="#FFCC00" />
          <stop offset="0.5672" stop-color="#FE4A05" />
          <stop offset="0.6942" stop-color="#FF0F3F" />
          <stop offset="1" stop-color="#FE0657" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_3569_3335"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.5584 21.6878) rotate(-59.8703) scale(7.26155 9.45372)"
        >
          <stop stop-color="#FFCC00" />
          <stop offset="1" stop-color="#FFCC00" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_3569_3335"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(2.98737 0.89388) rotate(164.274) scale(13.9008 4.736)"
        >
          <stop stop-color="#780CFF" />
          <stop offset="1" stop-color="#820BFF" stop-opacity="0" />
        </radialGradient>
        <clipPath id="clip0_3569_3335">
          <rect width="22" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  fbIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <g clip-path="url(#clip0_3569_3342)">
        <path
          d="M22.0024 10.998C22.0024 4.92337 17.0771 -0.00195312 11.0024 -0.00195312C4.92777 -0.00195312 0.00244141 4.92337 0.00244141 10.998C0.00244141 16.488 4.02438 21.039 9.28384 21.865V14.1785H6.49014V10.998H9.28384V8.57406C9.28384 5.81748 10.9266 4.29379 13.4388 4.29379C14.6423 4.29379 15.9015 4.5088 15.9015 4.5088V7.21588H14.5139C13.148 7.21588 12.721 8.06358 12.721 8.93448V10.998H15.7715L15.2843 14.1785H12.721V21.865C17.9805 21.0405 22.0024 16.4895 22.0024 10.998Z"
          fill="#1977F3"
        />
        <path
          d="M15.2795 14.1801L15.7667 10.9997H12.7163V8.93611C12.7163 8.06675 13.1417 7.2175 14.5091 7.2175H15.8967V4.51043C15.8967 4.51043 14.6375 4.29541 13.434 4.29541C10.9219 4.29541 9.27905 5.81756 9.27905 8.57568V10.9997H6.48535V14.1801H9.27905V21.8666C9.83903 21.9548 10.4129 21.9997 10.9977 21.9997C11.5824 21.9997 12.1563 21.9533 12.7163 21.8666V14.1801H15.2795Z"
          fill="#FEFEFE"
        />
      </g>
      <defs>
        <clipPath id="clip0_3569_3342">
          <rect width="22" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  twitterIcon: `
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="22" height="22" viewBox="0 0 22 22" fill="none">
      <rect width="22" height="22" rx="1.76" fill="url(#pattern0_3569_3346)" />
      <defs>
        <pattern id="pattern0_3569_3346" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_3569_3346" transform="scale(0.0025)" />
        </pattern>
        <image id="image0_3569_3346" width="400" height="400" preserveAspectRatio="none" xlink:href="data:image/jpeg;base64,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" />
      </defs>
    </svg>
  `,
  linkedInIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <g clip-path="url(#clip0_3569_3347)">
        <path
          d="M18.9454 18.5913H15.6802V13.5283C15.6802 12.321 15.6585 10.7668 13.982 10.7668C12.2814 10.7668 12.0212 12.0822 12.0212 13.4404V18.591H8.756V8.17933H11.8906V9.6022H11.9345C12.2481 9.07112 12.7014 8.63423 13.2461 8.33806C13.7907 8.04189 14.4063 7.89753 15.0272 7.92035C18.3366 7.92035 18.9468 10.0757 18.9468 12.8797L18.9454 18.5913ZM5.0718 6.75613C4.69704 6.7562 4.33067 6.64623 4.01903 6.44013C3.70739 6.23403 3.46449 5.94106 3.32101 5.59826C3.17754 5.25546 3.13994 4.87823 3.21298 4.51428C3.28603 4.15033 3.46644 3.816 3.73139 3.55357C3.99634 3.29113 4.33393 3.11239 4.70147 3.03993C5.06902 2.96747 5.45001 3.00456 5.79626 3.1465C6.14252 3.28844 6.4385 3.52886 6.64676 3.83735C6.85502 4.14585 6.96622 4.50857 6.96629 4.87964C6.96633 5.12602 6.91736 5.36999 6.82217 5.59764C6.72699 5.82528 6.58747 6.03213 6.41155 6.20638C6.23563 6.38063 6.02676 6.51886 5.79689 6.61319C5.56701 6.70751 5.32063 6.75609 5.0718 6.75613ZM6.70439 18.5913H3.43581V8.17933H6.70439V18.5913ZM20.5732 0.00148657H1.79507C1.36886 -0.00327585 0.958157 0.159701 0.653242 0.454603C0.348327 0.749505 0.174147 1.1522 0.168945 1.57421V20.2445C0.173969 20.6668 0.348047 21.0697 0.652951 21.3649C0.957856 21.6602 1.36865 21.8234 1.79507 21.819H20.5732C21.0005 21.8243 21.4124 21.6614 21.7185 21.3662C22.0246 21.071 22.1999 20.6676 22.2058 20.2445V1.57287C22.1997 1.15002 22.0243 0.746863 21.7182 0.451968C21.4121 0.157073 21.0003 -0.00543789 20.5732 0.000138935"
          fill="#0A66C2"
        />
      </g>
      <defs>
        <clipPath id="clip0_3569_3347">
          <rect width="22" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  whatsAppIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <g clip-path="url(#clip0_3569_3349)">
        <path
          d="M22.0024 16.4152C22.0024 16.5357 21.9987 16.7957 21.9911 16.9991C21.9723 17.4926 21.9346 18.1292 21.8744 18.4193C21.7839 18.8563 21.6521 19.2669 21.475 19.6097C21.2679 20.0165 21.0042 20.3782 20.6877 20.6909C20.375 21.0035 20.0134 21.2672 19.6066 21.4744C19.2637 21.6515 18.8494 21.7833 18.4086 21.8737C18.1223 21.9302 17.4894 21.9717 16.9997 21.9867C16.7963 21.9943 16.5363 21.998 16.4158 21.998H5.58155C5.461 21.998 5.20107 21.9943 4.99765 21.9867C4.50415 21.9679 3.86751 21.9302 3.57744 21.87C3.14046 21.7796 2.72984 21.6477 2.38703 21.4706C1.98018 21.2635 1.61854 20.9998 1.30587 20.6833C0.993195 20.3706 0.729496 20.009 0.522304 19.6022C0.34525 19.2593 0.2134 18.845 0.122989 18.4042C0.0664825 18.1179 0.0250441 17.485 0.00997565 16.9953C0.00620853 16.7957 0.00244141 16.5357 0.00244141 16.4152V5.58092C0.00244141 5.46038 0.00620853 5.20044 0.0137428 4.99702C0.0325784 4.50353 0.0702496 3.86688 0.130524 3.57681C0.220935 3.13983 0.352784 2.72921 0.529839 2.3864C0.737031 1.97955 1.00073 1.61791 1.3134 1.30524C1.62607 0.992567 1.98772 0.728869 2.39456 0.521677C2.73737 0.344622 3.15176 0.212773 3.59251 0.122362C3.87881 0.0658551 4.51169 0.0244167 5.00141 0.00934825C5.20484 0.001814 5.46477 -0.00195312 5.58532 -0.00195312H16.4196C16.5401 -0.00195312 16.8 0.001814 17.0035 0.00934825C17.497 0.0281839 18.1336 0.0658551 18.4237 0.126129C18.8607 0.21654 19.2713 0.348389 19.6141 0.525444C20.0209 0.732636 20.3826 0.996335 20.6952 1.31277C21.0079 1.62544 21.2716 1.98709 21.4788 2.39394C21.6559 2.73675 21.7877 3.15113 21.8781 3.59188C21.9346 3.87818 21.9761 4.51106 21.9911 5.00079C21.9987 5.20421 22.0024 5.46414 22.0024 5.58469V16.4152Z"
          fill="url(#paint0_linear_3569_3349)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.7911 5.26865C15.3106 3.78817 13.3404 2.9707 11.2422 2.9707C6.91749 2.9707 3.40277 6.4892 3.399 10.8101C3.399 12.1926 3.76065 13.5413 4.44626 14.7279L3.33496 18.7926L7.49387 17.7039C8.63907 18.3293 9.92743 18.657 11.2422 18.657H11.2459C15.5668 18.657 19.0853 15.1385 19.0891 10.8176C19.0891 8.71933 18.2716 6.74913 16.7911 5.26865ZM11.2459 17.331C10.0743 17.331 8.92537 17.0145 7.92708 16.4231L7.68975 16.2837L5.22229 16.9317L5.88154 14.5282L5.72708 14.2834C5.07537 13.2474 4.7288 12.0457 4.7288 10.8139C4.7288 7.22002 7.65585 4.29673 11.2497 4.29673C12.9901 4.29673 14.6288 4.97481 15.8569 6.20666C17.0887 7.43851 17.7668 9.07721 17.763 10.8176C17.7593 14.4077 14.836 17.331 11.2459 17.331ZM14.8209 12.4526C14.625 12.3546 13.6606 11.88 13.4836 11.8159C13.3028 11.7519 13.1747 11.718 13.0428 11.9139C12.911 12.1097 12.538 12.5505 12.4213 12.6823C12.3082 12.8142 12.1915 12.8293 11.9956 12.7313C11.7997 12.6334 11.1668 12.4262 10.4209 11.7594C9.83702 11.2395 9.44524 10.5991 9.33222 10.4032C9.21921 10.2073 9.32092 10.1019 9.41886 10.0039C9.50551 9.91728 9.61476 9.77413 9.7127 9.66111C9.81065 9.5481 9.84455 9.46522 9.90859 9.33337C9.97263 9.20153 9.94249 9.08851 9.89352 8.99057C9.84455 8.89262 9.45277 7.92824 9.29078 7.53646C9.13256 7.15598 8.97058 7.20495 8.85003 7.20118C8.73702 7.19365 8.60517 7.19365 8.47332 7.19365C8.34147 7.19365 8.13051 7.24262 7.94969 7.43851C7.76886 7.6344 7.26407 8.10906 7.26407 9.07344C7.26407 10.0378 7.96476 10.9683 8.0627 11.1002C8.16065 11.232 9.44523 13.2097 11.4117 14.0573C11.8788 14.2608 12.2442 14.3813 12.5305 14.4717C13.0014 14.6224 13.4271 14.5998 13.7661 14.5508C14.1428 14.4943 14.9264 14.0762 15.0884 13.6204C15.2504 13.1645 15.2504 12.769 15.2014 12.6899C15.1449 12.5995 15.0168 12.5505 14.8209 12.4526Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_3569_3349"
          x1="11.0033"
          y1="21.9997"
          x2="11.0033"
          y2="-0.00195312"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#25CF43" />
          <stop offset="1" stop-color="#61FD7D" />
        </linearGradient>
        <clipPath id="clip0_3569_3349">
          <rect width="22" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  phoneIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M4.56717 9.43308C3.31266 8.17613 2.34789 6.66029 1.74034 4.99158C1.40609 4.07925 1.71234 3.07708 2.3995 2.38991L2.82475 1.96525C2.93908 1.85069 3.07488 1.7598 3.22437 1.69779C3.37386 1.63578 3.53412 1.60386 3.69596 1.60386C3.85781 1.60386 4.01806 1.63578 4.16755 1.69779C4.31705 1.7598 4.45284 1.85069 4.56717 1.96525L5.56292 2.961C5.67748 3.07532 5.76836 3.21112 5.83037 3.36061C5.89238 3.5101 5.9243 3.67036 5.9243 3.8322C5.9243 3.99405 5.89238 4.1543 5.83037 4.3038C5.76836 4.45329 5.67748 4.58909 5.56292 4.70341L5.31792 4.94841C5.21985 5.04646 5.14206 5.16286 5.08899 5.29098C5.03591 5.41909 5.00859 5.55641 5.00859 5.69508C5.00859 5.83375 5.03591 5.97107 5.08899 6.09918C5.14206 6.2273 5.21985 6.3437 5.31792 6.44175L7.55792 8.68233C7.65597 8.7804 7.77237 8.85819 7.90048 8.91126C8.0286 8.96434 8.16591 8.99166 8.30459 8.99166C8.44326 8.99166 8.58057 8.96434 8.70869 8.91126C8.8368 8.85819 8.95321 8.7804 9.05125 8.68233L9.29684 8.43733C9.41116 8.32277 9.54696 8.23189 9.69645 8.16988C9.84595 8.10787 10.0062 8.07595 10.168 8.07595C10.3299 8.07595 10.4901 8.10787 10.6396 8.16988C10.7891 8.23189 10.9249 8.32277 11.0393 8.43733L12.035 9.43308C12.1496 9.54741 12.2404 9.6832 12.3025 9.83269C12.3645 9.98219 12.3964 10.1424 12.3964 10.3043C12.3964 10.4661 12.3645 10.6264 12.3025 10.7759C12.2404 10.9254 12.1496 11.0612 12.035 11.1755L11.6103 11.6002C10.9232 12.2879 9.921 12.5942 9.00867 12.2599C7.33996 11.6524 5.82412 10.6876 4.56717 9.43308Z"
        stroke="#041D37"
        stroke-width="0.875"
        stroke-linejoin="round"
      />
    </svg>
  ),
  linkIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M5.83301 7.58335C6.08352 7.91826 6.40313 8.19538 6.77016 8.3959C7.13719 8.59643 7.54305 8.71567 7.96022 8.74555C8.37739 8.77542 8.7961 8.71523 9.18796 8.56906C9.57982 8.42288 9.93566 8.19414 10.2313 7.89835L11.9813 6.14835C12.5126 5.59826 12.8066 4.86151 12.8 4.09677C12.7933 3.33203 12.4866 2.60049 11.9458 2.05972C11.405 1.51894 10.6735 1.2122 9.90876 1.20555C9.14402 1.19891 8.40726 1.49289 7.85717 2.02419L6.85384 3.02169"
        stroke="#041D37"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.16629 6.41672C7.91578 6.08181 7.59617 5.80469 7.22914 5.60417C6.86211 5.40364 6.45625 5.2844 6.03908 5.25452C5.62192 5.22465 5.2032 5.28484 4.81134 5.43101C4.41948 5.57719 4.06364 5.80593 3.76796 6.10172L2.01796 7.85172C1.48667 8.40181 1.19268 9.13856 1.19933 9.9033C1.20597 10.668 1.51272 11.3996 2.05349 11.9404C2.59426 12.4811 3.3258 12.7879 4.09054 12.7945C4.85528 12.8012 5.59204 12.5072 6.14213 11.9759L7.13963 10.9784"
        stroke="#041D37"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  timerIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
    >
      <path
        d="M7.5 13.625C10.6066 13.625 13.125 11.1066 13.125 8C13.125 4.8934 10.6066 2.375 7.5 2.375C4.3934 2.375 1.875 4.8934 1.875 8C1.875 11.1066 4.3934 13.625 7.5 13.625Z"
        stroke="#278D27"
        stroke-width="1.25"
      />
      <path
        d="M10.3125 8H7.65625C7.61481 8 7.57507 7.98354 7.54576 7.95424C7.51646 7.92493 7.5 7.88519 7.5 7.84375V5.8125"
        stroke="#278D27"
        stroke-width="1.25"
        stroke-linecap="round"
      />
    </svg>
  ),
  verifiedIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clip-path="url(#clip0_2338_12283)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 7C0 5.14348 0.737498 3.36301 2.05025 2.05025C3.36301 0.737498 5.14348 0 7 0C8.85652 0 10.637 0.737498 11.9497 2.05025C13.2625 3.36301 14 5.14348 14 7C14 8.85652 13.2625 10.637 11.9497 11.9497C10.637 13.2625 8.85652 14 7 14C5.14348 14 3.36301 13.2625 2.05025 11.9497C0.737498 10.637 0 8.85652 0 7ZM6.60053 9.996L10.6307 4.95787L9.90267 4.37547L6.46613 8.66973L4.032 6.6416L3.43467 7.3584L6.60053 9.996Z"
          fill="#4DB847"
        />
      </g>
      <defs>
        <clipPath id="clip0_2338_12283">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  appManagementIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M9.91683 0.583252H4.0835C3.117 0.583252 2.3335 1.36675 2.3335 2.33325V11.6666C2.3335 12.6331 3.117 13.4166 4.0835 13.4166H9.91683C10.8833 13.4166 11.6668 12.6331 11.6668 11.6666V2.33325C11.6668 1.36675 10.8833 0.583252 9.91683 0.583252Z"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.8335 11.0833H8.16683"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  userManagementIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clip-path="url(#clip0_3645_1109)">
        <path
          d="M6.5 6C7.88071 6 9 4.88071 9 3.5C9 2.11929 7.88071 1 6.5 1C5.11929 1 4 2.11929 4 3.5C4 4.88071 5.11929 6 6.5 6Z"
          stroke="white"
          stroke-width="1.07143"
        />
        <path
          d="M6.12516 7.5835C3.548 7.5835 1.4585 8.75891 1.4585 10.2085C1.4585 11.6581 1.4585 12.8335 6.12516 12.8335"
          stroke="white"
          stroke-linecap="round"
        />
        <path
          d="M9.00293 7.58606C9.36477 7.29023 9.88523 7.29023 10.2471 7.58606C10.3334 7.65666 10.4114 7.75609 10.4844 7.84583C10.5061 7.87256 10.518 7.8876 10.5273 7.89856C10.5355 7.90812 10.5361 7.90924 10.5342 7.90735C10.5539 7.92668 10.5808 7.93723 10.6084 7.93762C10.6098 7.93756 10.6133 7.9372 10.6201 7.93665C10.6344 7.93548 10.6534 7.9343 10.6875 7.93079C10.8025 7.91891 10.9281 7.90307 11.0391 7.91418C11.5042 7.96081 11.8723 8.32891 11.9189 8.79407C11.9301 8.90503 11.9142 9.0306 11.9023 9.14563C11.8988 9.1797 11.8976 9.19872 11.8965 9.21301C11.8959 9.2198 11.8956 9.22333 11.8955 9.22473C11.8959 9.25235 11.9064 9.27922 11.9258 9.29895C11.9239 9.29702 11.925 9.29766 11.9346 9.30579C11.9455 9.3151 11.9606 9.32703 11.9873 9.34875C12.077 9.4217 12.1765 9.49974 12.2471 9.58606C12.5429 9.9479 12.5429 10.4684 12.2471 10.8302C12.1765 10.9165 12.077 10.9946 11.9873 11.0675C11.9606 11.0892 11.9455 11.1012 11.9346 11.1105C11.925 11.1186 11.9239 11.1192 11.9258 11.1173C11.9064 11.137 11.8959 11.1639 11.8955 11.1915C11.8956 11.1929 11.8959 11.1965 11.8965 11.2032C11.8976 11.2175 11.8988 11.2366 11.9023 11.2706C11.9142 11.3857 11.9301 11.5112 11.9189 11.6222C11.8723 12.0874 11.5042 12.4555 11.0391 12.5021C10.9281 12.5132 10.8025 12.4974 10.6875 12.4855C10.6534 12.482 10.6344 12.4808 10.6201 12.4796C10.6133 12.4791 10.6098 12.4787 10.6084 12.4786C10.5808 12.479 10.5539 12.4896 10.5342 12.5089C10.5361 12.507 10.5355 12.5081 10.5273 12.5177C10.518 12.5287 10.5061 12.5437 10.4844 12.5704C10.4114 12.6602 10.3334 12.7596 10.2471 12.8302C9.88523 13.126 9.36477 13.126 9.00293 12.8302C8.91661 12.7596 8.83857 12.6602 8.76562 12.5704C8.7439 12.5437 8.73197 12.5287 8.72266 12.5177C8.71453 12.5081 8.71389 12.507 8.71582 12.5089C8.69609 12.4896 8.66922 12.479 8.6416 12.4786C8.6402 12.4787 8.63667 12.4791 8.62988 12.4796C8.61559 12.4808 8.59657 12.482 8.5625 12.4855C8.44747 12.4974 8.3219 12.5132 8.21094 12.5021C7.74578 12.4555 7.37768 12.0874 7.33105 11.6222C7.31994 11.5112 7.33578 11.3857 7.34766 11.2706C7.35117 11.2366 7.35235 11.2175 7.35352 11.2032C7.35407 11.1965 7.35443 11.1929 7.35449 11.1915C7.3541 11.1639 7.34355 11.137 7.32422 11.1173C7.32611 11.1192 7.32499 11.1186 7.31543 11.1105C7.30447 11.1012 7.28943 11.0892 7.2627 11.0675C7.17296 10.9946 7.07353 10.9165 7.00293 10.8302C6.7071 10.4684 6.7071 9.9479 7.00293 9.58606C7.07353 9.49974 7.17296 9.42169 7.2627 9.34875C7.28943 9.32703 7.30447 9.31509 7.31543 9.30579C7.32499 9.29766 7.32611 9.29702 7.32422 9.29895C7.34355 9.27922 7.3541 9.25235 7.35449 9.22473C7.35443 9.22333 7.35407 9.2198 7.35352 9.21301C7.35235 9.19872 7.35117 9.1797 7.34766 9.14563C7.33578 9.0306 7.31994 8.90503 7.33105 8.79407C7.37768 8.32891 7.74578 7.96081 8.21094 7.91418C8.3219 7.90307 8.44747 7.91891 8.5625 7.93079C8.59657 7.9343 8.61559 7.93548 8.62988 7.93665C8.63667 7.9372 8.6402 7.93756 8.6416 7.93762C8.66922 7.93723 8.69609 7.92668 8.71582 7.90735C8.71389 7.90924 8.71453 7.90812 8.72266 7.89856C8.73196 7.8876 8.7439 7.87256 8.76562 7.84583C8.83856 7.75609 8.91661 7.65666 9.00293 7.58606Z"
          stroke="white"
          stroke-width="0.875"
        />
        <rect
          x="8.82275"
          y="9.40601"
          width="1.60417"
          height="1.60417"
          rx="0.721875"
          stroke="white"
          stroke-width="0.875"
        />
      </g>
      <defs>
        <clipPath id="clip0_3645_1109">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  roleManagementIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clip-path="url(#clip0_3645_856)">
        <path
          d="M6.5 6.16663C7.88071 6.16663 9 5.04734 9 3.66663C9 2.28591 7.88071 1.16663 6.5 1.16663C5.11929 1.16663 4 2.28591 4 3.66663C4 5.04734 5.11929 6.16663 6.5 6.16663Z"
          stroke="white"
        />
        <path
          d="M11.3333 10.2084C11.3333 11.658 11.3333 12.8334 6.66667 12.8334C2 12.8334 2 11.658 2 10.2084C2 8.75879 4.0895 7.58337 6.66667 7.58337C9.24383 7.58337 11.3333 8.75879 11.3333 10.2084Z"
          stroke="white"
        />
        <path
          d="M13 4L11.1414 5.85858C11.0633 5.93668 11.0633 6.06332 11.1414 6.14142L13 8"
          stroke="white"
          stroke-linecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3645_856">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  grievancesIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clip-path="url(#clip0_3645_837)">
        <path
          d="M12.8332 6.12504V3.50004C12.8332 3.19062 12.7103 2.89388 12.4915 2.67508C12.2727 2.45629 11.9759 2.33337 11.6665 2.33337H2.33317C2.02375 2.33337 1.72701 2.45629 1.50821 2.67508C1.28942 2.89388 1.1665 3.19062 1.1665 3.50004V10.5C1.1665 11.1417 1.6915 11.6667 2.33317 11.6667H9.62484"
          stroke="white"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.8332 4.0835L7.60067 7.4085C7.42058 7.52133 7.21236 7.58117 6.99984 7.58117C6.78732 7.58117 6.5791 7.52133 6.399 7.4085L1.1665 4.0835M11.6665 8.16683V10.5002M11.6665 12.8335V12.8393"
          stroke="white"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3645_837">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  feedBackIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clip-path="url(#clip0_3645_846)">
        <path
          d="M6.49951 5.99988C7.88022 5.99988 8.99951 4.88059 8.99951 3.49988C8.99951 2.11917 7.88022 0.999878 6.49951 0.999878C5.1188 0.999878 3.99951 2.11917 3.99951 3.49988C3.99951 4.88059 5.1188 5.99988 6.49951 5.99988Z"
          stroke="white"
        />
        <path
          d="M5.99967 7.4165C3.42251 7.4165 1.33301 8.59192 1.33301 10.0415C1.33301 11.4911 1.33301 12.6665 5.99967 12.6665"
          stroke="white"
          stroke-linecap="round"
        />
        <path
          d="M8.79143 13C8.72286 13 8.65143 12.9886 8.58286 12.9657C8.45403 12.9247 8.34176 12.8435 8.26255 12.7339C8.18335 12.6244 8.14139 12.4923 8.14286 12.3571V11.5543C7.49714 11.4514 7 10.8886 7 10.2143V8.35714C7 7.60857 7.60857 7 8.35714 7H11.6429C12.3914 7 13 7.60857 13 8.35714V10.2143C13 10.9629 12.3914 11.5714 11.6429 11.5714H10.18L9.3 12.7429C9.17429 12.9086 8.98857 13 8.79143 13ZM8.35714 7.71429C8.00286 7.71429 7.71429 8.00286 7.71429 8.35714V10.2143C7.71429 10.5686 8.00286 10.8571 8.35714 10.8571H8.85714V12.1429L9.82286 10.8571H11.6457C12 10.8571 12.2886 10.5686 12.2886 10.2143V8.35714C12.2886 8.00286 12 7.71429 11.6457 7.71429H8.35714Z"
          fill="white"
          stroke="white"
          stroke-width="0.2"
        />
      </g>
      <defs>
        <clipPath id="clip0_3645_846">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  adminUserIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clip-path="url(#clip0_3645_6427)">
        <path
          d="M6.99984 13.4167C3.75825 12.6963 1.1665 9.63787 1.1665 6.41671V2.91671L6.99984 0.583374L12.8332 2.91671V6.41671C12.8332 9.63904 10.2414 12.6963 6.99984 13.4167ZM2.33317 3.50004V6.41671C2.36651 7.76545 2.84088 9.06611 3.68369 10.1196C4.5265 11.1731 5.69131 11.9215 6.99984 12.25C8.30836 11.9215 9.47317 11.1731 10.316 10.1196C11.1588 9.06611 11.6332 7.76545 11.6665 6.41671V3.50004L6.99984 1.75004L2.33317 3.50004Z"
          fill="white"
        />
        <path
          d="M7 6C7.55228 6 8 5.55228 8 5C8 4.44772 7.55228 4 7 4C6.44772 4 6 4.44772 6 5C6 5.55228 6.44772 6 7 6Z"
          stroke="white"
        />
        <path
          d="M9 8.125C9 8.74625 9 9.25 7 9.25C5 9.25 5 8.74625 5 8.125C5 7.50375 5.8955 7 7 7C8.1045 7 9 7.50375 9 8.125Z"
          stroke="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3645_6427">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  pollManagementIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clip-path="url(#clip0_3645_3636)">
        <path
          d="M7 0.875C6.53587 0.875 6.09075 1.05937 5.76256 1.38756C5.43437 1.71575 5.25 2.16087 5.25 2.625V11.375C5.25 11.8391 5.43437 12.2842 5.76256 12.6124C6.09075 12.9406 6.53587 13.125 7 13.125C7.46413 13.125 7.90925 12.9406 8.23744 12.6124C8.56563 12.2842 8.75 11.8391 8.75 11.375V2.625C8.75 2.16087 8.56563 1.71575 8.23744 1.38756C7.90925 1.05937 7.46413 0.875 7 0.875ZM7.875 2.625V11.375C7.875 11.6071 7.78281 11.8296 7.61872 11.9937C7.45462 12.1578 7.23206 12.25 7 12.25C6.76794 12.25 6.54538 12.1578 6.38128 11.9937C6.21719 11.8296 6.125 11.6071 6.125 11.375V2.625C6.125 2.39294 6.21719 2.17038 6.38128 2.00628C6.54538 1.84219 6.76794 1.75 7 1.75C7.23206 1.75 7.45462 1.84219 7.61872 2.00628C7.78281 2.17038 7.875 2.39294 7.875 2.625ZM2.625 6.125C2.16087 6.125 1.71575 6.30937 1.38756 6.63756C1.05937 6.96575 0.875 7.41087 0.875 7.875V11.375C0.875 11.8391 1.05937 12.2842 1.38756 12.6124C1.71575 12.9406 2.16087 13.125 2.625 13.125C3.08913 13.125 3.53425 12.9406 3.86244 12.6124C4.19063 12.2842 4.375 11.8391 4.375 11.375V7.875C4.375 7.41087 4.19063 6.96575 3.86244 6.63756C3.53425 6.30937 3.08913 6.125 2.625 6.125ZM3.5 11.375C3.5 11.6071 3.40781 11.8296 3.24372 11.9937C3.07962 12.1578 2.85706 12.25 2.625 12.25C2.39294 12.25 2.17038 12.1578 2.00628 11.9937C1.84219 11.8296 1.75 11.6071 1.75 11.375V7.875C1.75 7.64294 1.84219 7.42038 2.00628 7.25628C2.17038 7.09219 2.39294 7 2.625 7C2.85706 7 3.07962 7.09219 3.24372 7.25628C3.40781 7.42038 3.5 7.64294 3.5 7.875V11.375ZM9.625 6.125C9.625 5.66087 9.80937 5.21575 10.1376 4.88756C10.4658 4.55937 10.9109 4.375 11.375 4.375C11.8391 4.375 12.2842 4.55937 12.6124 4.88756C12.9406 5.21575 13.125 5.66087 13.125 6.125V11.375C13.125 11.8391 12.9406 12.2842 12.6124 12.6124C12.2842 12.9406 11.8391 13.125 11.375 13.125C10.9109 13.125 10.4658 12.9406 10.1376 12.6124C9.80937 12.2842 9.625 11.8391 9.625 11.375V6.125ZM12.25 6.125C12.25 5.89294 12.1578 5.67038 11.9937 5.50628C11.8296 5.34219 11.6071 5.25 11.375 5.25C11.1429 5.25 10.9204 5.34219 10.7563 5.50628C10.5922 5.67038 10.5 5.89294 10.5 6.125V11.375C10.5 11.6071 10.5922 11.8296 10.7563 11.9937C10.9204 12.1578 11.1429 12.25 11.375 12.25C11.6071 12.25 11.8296 12.1578 11.9937 11.9937C12.1578 11.8296 12.25 11.6071 12.25 11.375V6.125Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3645_3636">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  eventMangamentIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clip-path="url(#clip0_3645_3644)">
        <path
          d="M1.16797 6.99528C1.16797 4.79553 1.16797 3.69536 1.85164 3.01228C2.5353 2.3292 3.63489 2.32861 5.83464 2.32861H8.16797C10.3677 2.32861 11.4679 2.32861 12.151 3.01228C12.8341 3.69595 12.8346 4.79553 12.8346 6.99528V8.16195C12.8346 10.3617 12.8346 11.4619 12.151 12.1449C11.4673 12.828 10.3677 12.8286 8.16797 12.8286H5.83464C3.63489 12.8286 2.53472 12.8286 1.85164 12.1449C1.16855 11.4613 1.16797 10.3617 1.16797 8.16195V6.99528Z"
          stroke="white"
        />
        <path
          d="M4.0835 2.32861V1.45361M9.91683 2.32861V1.45361M1.4585 5.24528H12.5418"
          stroke="white"
          stroke-linecap="round"
        />
        <rect x="8" y="8" width="3" height="3" rx="1" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_3645_3644">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  governmentSchemeIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clip-path="url(#clip0_3645_3666)">
        <path
          d="M12.2502 4.08337C12.3988 4.08354 12.5419 4.14047 12.65 4.24254C12.7581 4.3446 12.8231 4.4841 12.8319 4.63252C12.8406 4.78095 12.7923 4.9271 12.6968 5.04111C12.6014 5.15512 12.4661 5.2284 12.3184 5.24596L12.2502 5.25004V11.0834C12.3988 11.0835 12.5419 11.1405 12.65 11.2425C12.7581 11.3446 12.8231 11.4841 12.8319 11.6325C12.8406 11.7809 12.7923 11.9271 12.6968 12.0411C12.6014 12.1551 12.4661 12.2284 12.3184 12.246L12.2502 12.25H1.75017C1.60149 12.2499 1.45848 12.1929 1.35037 12.0909C1.24226 11.9888 1.1772 11.8493 1.16848 11.7009C1.15977 11.5525 1.20806 11.4063 1.30349 11.2923C1.39892 11.1783 1.53428 11.105 1.68192 11.0875L1.75017 11.0834V5.25004C1.60149 5.24988 1.45848 5.19294 1.35037 5.09088C1.24226 4.98881 1.1772 4.84932 1.16848 4.70089C1.15977 4.55247 1.20806 4.40632 1.30349 4.29231C1.39892 4.17829 1.53428 4.10502 1.68192 4.08746L1.75017 4.08337H12.2502ZM11.0835 5.25004H2.91683V11.0834H4.0835V7.00004C4.0835 6.84533 4.14496 6.69696 4.25436 6.58756C4.36375 6.47817 4.51212 6.41671 4.66683 6.41671C4.82154 6.41671 4.96992 6.47817 5.07931 6.58756C5.18871 6.69696 5.25017 6.84533 5.25017 7.00004V11.0834H6.41683V7.00004C6.41683 6.84533 6.47829 6.69696 6.58769 6.58756C6.69708 6.47817 6.84546 6.41671 7.00017 6.41671C7.15488 6.41671 7.30325 6.47817 7.41265 6.58756C7.52204 6.69696 7.5835 6.84533 7.5835 7.00004V11.0834H8.75017V7.00004C8.75017 6.84533 8.81163 6.69696 8.92102 6.58756C9.03042 6.47817 9.17879 6.41671 9.3335 6.41671C9.48821 6.41671 9.63658 6.47817 9.74598 6.58756C9.85538 6.69696 9.91683 6.84533 9.91683 7.00004V11.0834H11.0835V5.25004ZM10.5002 2.33337C10.6549 2.33337 10.8033 2.39483 10.9126 2.50423C11.022 2.61362 11.0835 2.762 11.0835 2.91671C11.0835 3.07142 11.022 3.21979 10.9126 3.32919C10.8033 3.43858 10.6549 3.50004 10.5002 3.50004H3.50017C3.34546 3.50004 3.19708 3.43858 3.08769 3.32919C2.97829 3.21979 2.91683 3.07142 2.91683 2.91671C2.91683 2.762 2.97829 2.61362 3.08769 2.50423C3.19708 2.39483 3.34546 2.33337 3.50017 2.33337H10.5002Z"
          fill="white"
        />
        <path
          d="M11.6668 3.5H13.4168V4.66667H12.8335V11.0833H13.4168V12.25H0.583496V11.0833H1.16683V4.66667H0.583496V3.5H2.3335V2.33333C2.3335 2.17862 2.39495 2.03025 2.50435 1.92085C2.61375 1.81146 2.76212 1.75 2.91683 1.75H11.0835C11.2382 1.75 11.3866 1.81146 11.496 1.92085C11.6054 2.03025 11.6668 2.17862 11.6668 2.33333V3.5ZM11.6668 4.66667H2.3335V11.0833H4.0835V7H5.25016V11.0833H6.41683V7H7.5835V11.0833H8.75016V7H9.91683V11.0833H11.6668V4.66667ZM3.50016 2.91667V3.5H10.5002V2.91667H3.50016Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3645_3666">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  zoneDirectoryIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clip-path="url(#clip0_3645_3676)">
        <path
          d="M2.3335 4.66663C2.3335 3.01696 2.3335 2.19154 2.84625 1.67938C3.35841 1.16663 4.18383 1.16663 5.8335 1.16663H8.16683C9.8165 1.16663 10.6419 1.16663 11.1541 1.67938C11.6668 2.19154 11.6668 3.01696 11.6668 4.66663V9.33329C11.6668 10.983 11.6668 11.8084 11.1541 12.3205C10.6419 12.8333 9.8165 12.8333 8.16683 12.8333H5.8335C4.18383 12.8333 3.35841 12.8333 2.84625 12.3205C2.3335 11.8084 2.3335 10.983 2.3335 9.33329V4.66663Z"
          stroke="white"
        />
        <path
          d="M11.6073 9.33325H4.60733C4.06483 9.33325 3.79358 9.33325 3.57075 9.39275C3.27401 9.47232 3.00345 9.62861 2.78627 9.84589C2.56908 10.0632 2.41293 10.3338 2.3335 10.6306"
          stroke="white"
        />
        <path
          d="M4.66699 4.08325H9.33366M4.66699 6.12492H7.58366"
          stroke="white"
          stroke-linecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3645_3676">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  leaderProfileIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clip-path="url(#clip0_3645_3686)">
        <path
          d="M6.49951 5.99988C7.88022 5.99988 8.99951 4.88059 8.99951 3.49988C8.99951 2.11917 7.88022 0.999878 6.49951 0.999878C5.1188 0.999878 3.99951 2.11917 3.99951 3.49988C3.99951 4.88059 5.1188 5.99988 6.49951 5.99988Z"
          stroke="white"
        />
        <path
          d="M5.99967 7.4165C3.42251 7.4165 1.33301 8.59192 1.33301 10.0415C1.33301 11.4911 1.33301 12.6665 5.99967 12.6665"
          stroke="white"
          stroke-linecap="round"
        />
        <circle cx="9" cy="9" r="1.5" stroke="white" />
        <path
          d="M8 10V12.7586C8 12.8477 8.10771 12.8923 8.17071 12.8293L8.92929 12.0707C8.96834 12.0317 9.03166 12.0317 9.07071 12.0707L9.82929 12.8293C9.89229 12.8923 10 12.8477 10 12.7586V10"
          stroke="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3645_3686">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  newsManagementIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M1.75 2.33325V10.4999C1.75 10.8093 1.87292 11.1061 2.09171 11.3249C2.3105 11.5437 2.60725 11.6666 2.91667 11.6666H11.0833C11.3928 11.6666 11.6895 11.5437 11.9083 11.3249C12.1271 11.1061 12.25 10.8093 12.25 10.4999V4.66659H9.91667"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.75 2.33325C4.93928 2.33325 9.91667 2.33325 9.91667 2.33325V10.4999C9.91667 10.8093 10.0396 11.1061 10.2584 11.3249C10.4772 11.5437 10.7739 11.6666 11.0833 11.6666M7.58333 4.66659H4.08333M7.58333 6.99992H5.25"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),

  galleryManagementIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clip-path="url(#clip0_3867_1410)">
        <path
          d="M1.16675 8.16667C1.16675 5.96692 1.16675 4.86675 1.85041 4.18367C2.53408 3.50058 3.63366 3.5 5.83341 3.5H8.16675C10.3665 3.5 11.4667 3.5 12.1497 4.18367C12.8328 4.86733 12.8334 5.96692 12.8334 8.16667C12.8334 10.3664 12.8334 11.4666 12.1497 12.1497C11.4661 12.8327 10.3665 12.8333 8.16675 12.8333H5.83341C3.63366 12.8333 2.5335 12.8333 1.85041 12.1497C1.16733 11.466 1.16675 10.3664 1.16675 8.16667Z"
          stroke="white"
        />
        <path
          d="M2.33342 4.08333L2.32642 3.5C2.39175 2.95692 2.52883 2.58183 2.81467 2.29658C3.363 1.75 4.24617 1.75 6.0125 1.75H7.88558C9.65192 1.75 10.5345 1.75 11.0834 2.29658C11.3692 2.58183 11.5063 2.95692 11.5717 3.5V4.08333"
          stroke="white"
        />
        <path
          d="M10.2085 7C10.6917 7 11.0835 6.60825 11.0835 6.125C11.0835 5.64175 10.6917 5.25 10.2085 5.25C9.72525 5.25 9.3335 5.64175 9.3335 6.125C9.3335 6.60825 9.72525 7 10.2085 7Z"
          stroke="white"
        />
        <path
          d="M1.16675 8.45827L2.18875 7.56402C2.44491 7.34006 2.7766 7.2218 3.11667 7.23317C3.45674 7.24454 3.77979 7.3847 4.02041 7.62527L6.52291 10.1278C6.71711 10.3219 6.97357 10.4414 7.24715 10.465C7.52073 10.4887 7.7939 10.4152 8.01858 10.2573L8.193 10.1348C8.51709 9.90715 8.90882 9.79619 9.30414 9.82003C9.69947 9.84387 10.075 10.0011 10.3694 10.266L12.2501 11.9583"
          stroke="white"
          stroke-linecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3867_1410">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  increaseIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
    >
      <g clip-path="url(#clip0_2566_13131)">
        <path
          d="M5 10V1.25"
          stroke="#4DB847"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.5 4.5L5 1L1.5 4.5"
          stroke="#4DB847"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2566_13131">
          <rect
            width="10"
            height="10"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  decreaseIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
    >
      <g clip-path="url(#clip0_2566_13167)">
        <path
          d="M5 1V9.75"
          stroke="#EE3722"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.5 6.5L5 10L1.5 6.5"
          stroke="#EE3722"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2566_13167">
          <rect
            width="10"
            height="10"
            fill="white"
            transform="matrix(1 0 0 -1 0 10.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  calenderIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clip-path="url(#clip0_7472_8811)">
        <path
          d="M1.16797 6.99479C1.16797 4.79504 1.16797 3.69487 1.85164 3.01179C2.5353 2.32871 3.63489 2.32813 5.83464 2.32813H8.16797C10.3677 2.32813 11.4679 2.32812 12.151 3.01179C12.8341 3.69546 12.8346 4.79504 12.8346 6.99479V8.16146C12.8346 10.3612 12.8346 11.4614 12.151 12.1445C11.4673 12.8275 10.3677 12.8281 8.16797 12.8281H5.83464C3.63489 12.8281 2.53472 12.8281 1.85164 12.1445C1.16855 11.4608 1.16797 10.3612 1.16797 8.16146V6.99479Z"
          stroke="white"
        />
        <path
          d="M4.08301 2.32813V1.45312M9.91634 2.32813V1.45312M1.45801 5.24479H12.5413"
          stroke="white"
          stroke-linecap="round"
        />
        <path
          d="M10.502 9.91081C10.502 10.0655 10.4405 10.2139 10.3311 10.3233C10.2217 10.4327 10.0733 10.4941 9.91862 10.4941C9.76391 10.4941 9.61554 10.4327 9.50614 10.3233C9.39674 10.2139 9.33529 10.0655 9.33529 9.91081C9.33529 9.7561 9.39674 9.60772 9.50614 9.49833C9.61554 9.38893 9.76391 9.32747 9.91862 9.32747C10.0733 9.32747 10.2217 9.38893 10.3311 9.49833C10.4405 9.60772 10.502 9.7561 10.502 9.91081ZM10.502 7.57747C10.502 7.73218 10.4405 7.88056 10.3311 7.98995C10.2217 8.09935 10.0733 8.16081 9.91862 8.16081C9.76391 8.16081 9.61554 8.09935 9.50614 7.98995C9.39674 7.88056 9.33529 7.73218 9.33529 7.57747C9.33529 7.42276 9.39674 7.27439 9.50614 7.165C9.61554 7.0556 9.76391 6.99414 9.91862 6.99414C10.0733 6.99414 10.2217 7.0556 10.3311 7.165C10.4405 7.27439 10.502 7.42276 10.502 7.57747ZM7.58529 9.91081C7.58529 10.0655 7.52383 10.2139 7.41443 10.3233C7.30504 10.4327 7.15666 10.4941 7.00195 10.4941C6.84724 10.4941 6.69887 10.4327 6.58947 10.3233C6.48008 10.2139 6.41862 10.0655 6.41862 9.91081C6.41862 9.7561 6.48008 9.60772 6.58947 9.49833C6.69887 9.38893 6.84724 9.32747 7.00195 9.32747C7.15666 9.32747 7.30504 9.38893 7.41443 9.49833C7.52383 9.60772 7.58529 9.7561 7.58529 9.91081ZM7.58529 7.57747C7.58529 7.73218 7.52383 7.88056 7.41443 7.98995C7.30504 8.09935 7.15666 8.16081 7.00195 8.16081C6.84724 8.16081 6.69887 8.09935 6.58947 7.98995C6.48008 7.88056 6.41862 7.73218 6.41862 7.57747C6.41862 7.42276 6.48008 7.27439 6.58947 7.165C6.69887 7.0556 6.84724 6.99414 7.00195 6.99414C7.15666 6.99414 7.30504 7.0556 7.41443 7.165C7.52383 7.27439 7.58529 7.42276 7.58529 7.57747ZM4.66862 9.91081C4.66862 10.0655 4.60716 10.2139 4.49777 10.3233C4.38837 10.4327 4.24 10.4941 4.08529 10.4941C3.93058 10.4941 3.7822 10.4327 3.67281 10.3233C3.56341 10.2139 3.50195 10.0655 3.50195 9.91081C3.50195 9.7561 3.56341 9.60772 3.67281 9.49833C3.7822 9.38893 3.93058 9.32747 4.08529 9.32747C4.24 9.32747 4.38837 9.38893 4.49777 9.49833C4.60716 9.60772 4.66862 9.7561 4.66862 9.91081ZM4.66862 7.57747C4.66862 7.73218 4.60716 7.88056 4.49777 7.98995C4.38837 8.09935 4.24 8.16081 4.08529 8.16081C3.93058 8.16081 3.7822 8.09935 3.67281 7.98995C3.56341 7.88056 3.50195 7.73218 3.50195 7.57747C3.50195 7.42276 3.56341 7.27439 3.67281 7.165C3.7822 7.0556 3.93058 6.99414 4.08529 6.99414C4.24 6.99414 4.38837 7.0556 4.49777 7.165C4.60716 7.27439 4.66862 7.42276 4.66862 7.57747Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_7472_8811">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  calenderIconWhite: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M1.16785 6.99552C1.16785 4.79577 1.16785 3.69561 1.85151 3.01252C2.53518 2.32944 3.63476 2.32886 5.83451 2.32886H8.16785C10.3676 2.32886 11.4678 2.32886 12.1508 3.01252C12.8339 3.69619 12.8345 4.79577 12.8345 6.99552V8.16219C12.8345 10.3619 12.8345 11.4621 12.1508 12.1452C11.4672 12.8283 10.3676 12.8289 8.16785 12.8289H5.83451C3.63476 12.8289 2.5346 12.8289 1.85151 12.1452C1.16843 11.4615 1.16785 10.3619 1.16785 8.16219V6.99552Z"
        stroke="white"
      />
      <path
        d="M4.08337 2.32886V1.45386M9.91671 2.32886V1.45386M1.45837 5.24552H12.5417"
        stroke="white"
        stroke-linecap="round"
      />
      <path
        d="M10.5023 9.91105C10.5023 10.0658 10.4409 10.2141 10.3315 10.3235C10.2221 10.4329 10.0737 10.4944 9.91899 10.4944C9.76428 10.4944 9.6159 10.4329 9.50651 10.3235C9.39711 10.2141 9.33565 10.0658 9.33565 9.91105C9.33565 9.75634 9.39711 9.60797 9.50651 9.49857C9.6159 9.38918 9.76428 9.32772 9.91899 9.32772C10.0737 9.32772 10.2221 9.38918 10.3315 9.49857C10.4409 9.60797 10.5023 9.75634 10.5023 9.91105ZM10.5023 7.57772C10.5023 7.73243 10.4409 7.8808 10.3315 7.9902C10.2221 8.09959 10.0737 8.16105 9.91899 8.16105C9.76428 8.16105 9.6159 8.09959 9.50651 7.9902C9.39711 7.8808 9.33565 7.73243 9.33565 7.57772C9.33565 7.42301 9.39711 7.27464 9.50651 7.16524C9.6159 7.05584 9.76428 6.99438 9.91899 6.99438C10.0737 6.99438 10.2221 7.05584 10.3315 7.16524C10.4409 7.27464 10.5023 7.42301 10.5023 7.57772ZM7.58565 9.91105C7.58565 10.0658 7.52419 10.2141 7.4148 10.3235C7.3054 10.4329 7.15703 10.4944 7.00232 10.4944C6.84761 10.4944 6.69924 10.4329 6.58984 10.3235C6.48044 10.2141 6.41899 10.0658 6.41899 9.91105C6.41899 9.75634 6.48044 9.60797 6.58984 9.49857C6.69924 9.38918 6.84761 9.32772 7.00232 9.32772C7.15703 9.32772 7.3054 9.38918 7.4148 9.49857C7.52419 9.60797 7.58565 9.75634 7.58565 9.91105ZM7.58565 7.57772C7.58565 7.73243 7.52419 7.8808 7.4148 7.9902C7.3054 8.09959 7.15703 8.16105 7.00232 8.16105C6.84761 8.16105 6.69924 8.09959 6.58984 7.9902C6.48044 7.8808 6.41899 7.73243 6.41899 7.57772C6.41899 7.42301 6.48044 7.27464 6.58984 7.16524C6.69924 7.05584 6.84761 6.99438 7.00232 6.99438C7.15703 6.99438 7.3054 7.05584 7.4148 7.16524C7.52419 7.27464 7.58565 7.42301 7.58565 7.57772ZM4.66899 9.91105C4.66899 10.0658 4.60753 10.2141 4.49813 10.3235C4.38874 10.4329 4.24036 10.4944 4.08565 10.4944C3.93094 10.4944 3.78257 10.4329 3.67317 10.3235C3.56378 10.2141 3.50232 10.0658 3.50232 9.91105C3.50232 9.75634 3.56378 9.60797 3.67317 9.49857C3.78257 9.38918 3.93094 9.32772 4.08565 9.32772C4.24036 9.32772 4.38874 9.38918 4.49813 9.49857C4.60753 9.60797 4.66899 9.75634 4.66899 9.91105ZM4.66899 7.57772C4.66899 7.73243 4.60753 7.8808 4.49813 7.9902C4.38874 8.09959 4.24036 8.16105 4.08565 8.16105C3.93094 8.16105 3.78257 8.09959 3.67317 7.9902C3.56378 7.8808 3.50232 7.73243 3.50232 7.57772C3.50232 7.42301 3.56378 7.27464 3.67317 7.16524C3.78257 7.05584 3.93094 6.99438 4.08565 6.99438C4.24036 6.99438 4.38874 7.05584 4.49813 7.16524C4.60753 7.27464 4.66899 7.42301 4.66899 7.57772Z"
        fill="white"
      />
    </svg>
  ),
  eyeClose: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M3.63333 11.78C2.89922 11.0842 2.31997 10.2414 1.93333 9.30669C1.8673 9.15294 1.83325 8.98736 1.83325 8.82003C1.83325 8.6527 1.8673 8.48711 1.93333 8.33336C2.4468 7.08428 3.30743 6.00849 4.41333 5.23336C5.463 4.49984 6.71982 4.12139 8 4.15336C8.92105 4.13023 9.8346 4.32436 10.6667 4.72003M12.3733 5.86669C13.1035 6.56192 13.6803 7.40211 14.0667 8.33336C14.1327 8.48711 14.1667 8.6527 14.1667 8.82003C14.1667 8.98736 14.1327 9.15294 14.0667 9.30669C13.5532 10.5558 12.6926 11.6316 11.5867 12.4067C10.537 13.1402 9.28017 13.5187 8 13.4867C7.07894 13.5098 6.16539 13.3157 5.33333 12.92"
        stroke="black"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.80667 9.59996C5.71317 9.35058 5.66574 9.08629 5.66667 8.81996C5.66667 8.20112 5.9125 7.60763 6.35008 7.17004C6.78767 6.73246 7.38116 6.48663 8 6.48663C8.26667 6.48529 8.53067 6.53329 8.78 6.62663M10.1933 8.03996C10.2867 8.28929 10.3347 8.55329 10.3333 8.81996C10.3333 9.4388 10.0875 10.0323 9.64992 10.4699C9.21233 10.9075 8.61884 11.1533 8 11.1533C7.73367 11.1542 7.46938 11.1068 7.22 11.0133M2 13.8333L12.6667 3.16663"
        stroke="black"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  eyeOpen: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M1.93266 8.49006C1.86646 8.33519 1.83233 8.1685 1.83233 8.00006C1.83233 7.83163 1.86646 7.66494 1.93266 7.51006C2.47133 6.23006 3.33266 5.1534 4.41 4.41206C5.48733 3.67073 6.73533 3.29673 8 3.33606C9.26466 3.29673 10.512 3.67073 11.59 4.41206C12.668 5.1534 13.5287 6.23006 14.0673 7.51006C14.1335 7.66494 14.1677 7.83163 14.1677 8.00006C14.1677 8.1685 14.1335 8.33519 14.0673 8.49006C13.5287 9.77006 12.6673 10.8467 11.59 11.5881C10.5127 12.3294 9.26466 12.7034 8 12.6641C6.73533 12.7034 5.488 12.3294 4.41 11.5881C3.332 10.8467 2.47133 9.77006 1.93333 8.49006"
        stroke="black"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 10.3334C8.30642 10.3334 8.60983 10.2731 8.89293 10.1558C9.17602 10.0385 9.43324 9.86667 9.64991 9.65C9.86658 9.43333 10.0385 9.1761 10.1557 8.89301C10.273 8.60992 10.3333 8.3065 10.3333 8.00008C10.3333 7.69366 10.273 7.39025 10.1557 7.10715C10.0385 6.82406 9.86658 6.56684 9.64991 6.35017C9.43324 6.1335 9.17602 5.96162 8.89293 5.84436C8.60983 5.7271 8.30642 5.66675 8 5.66675C7.38116 5.66675 6.78767 5.91258 6.35008 6.35017C5.9125 6.78775 5.66666 7.38124 5.66666 8.00008C5.66666 8.61892 5.9125 9.21241 6.35008 9.65C6.78767 10.0876 7.38116 10.3334 8 10.3334Z"
        stroke="black"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  editIconWhite: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M7.58334 2.33332L11.6667 6.41666M8.20984 2.26624C8.64442 1.79549 8.86142 1.56041 9.09242 1.42274C9.36512 1.25951 9.67601 1.17104 9.99379 1.16622C10.3116 1.16141 10.625 1.24043 10.9025 1.39532C11.1376 1.52599 11.3616 1.75466 11.8096 2.21199C12.2576 2.66991 12.4816 2.89916 12.6088 3.13891C12.7605 3.42439 12.8376 3.74359 12.8331 4.06686C12.8285 4.39013 12.7423 4.70701 12.5825 4.98807C12.4483 5.22374 12.2179 5.44599 11.7565 5.88991L6.27142 11.1732C5.39759 12.0149 4.96067 12.4355 4.41467 12.649C3.86867 12.8625 3.26842 12.8462 2.06792 12.8152L1.90459 12.8106C1.53942 12.8012 1.35626 12.7966 1.25067 12.6758C1.14392 12.5551 1.15851 12.369 1.18767 11.9968L1.20342 11.795C1.28509 10.7473 1.32592 10.2235 1.53009 9.75216C1.73426 9.28082 2.08776 8.89874 2.79359 8.13399L8.20984 2.26624Z"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  approveIcon: (
    <svg width="20" height="20" fill="green" viewBox="0 0 24 24">
      <path d="M20.285 2l-11.285 11.292-5.285-5.292-3.715 3.708 9 9 15-15z" />
    </svg>
  ),
  rejectIcon: (
    <svg width="20" height="20" fill="red" viewBox="0 0 24 24">
      <path d="M18.364 5.636l-1.414-1.414L12 9.172 7.05 4.222 5.636 5.636 10.586 10.586 5.636 15.536l1.414 1.414L12 12.828l4.95 4.95 1.414-1.414L13.414 10.586z" />
    </svg>
  ),
  settingsIconWhite: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M7 8.75C7.9665 8.75 8.75 7.9665 8.75 7C8.75 6.0335 7.9665 5.25 7 5.25C6.0335 5.25 5.25 6.0335 5.25 7C5.25 7.9665 6.0335 8.75 7 8.75Z"
        stroke="white"
      />
      <path
        d="M8.0296 1.25541C7.81552 1.16675 7.54369 1.16675 7.00002 1.16675C6.45635 1.16675 6.18452 1.16675 5.97044 1.25541C5.82879 1.31405 5.70009 1.40002 5.59169 1.50842C5.48329 1.61682 5.39732 1.74552 5.33869 1.88716C5.28502 2.01725 5.26344 2.1695 5.25527 2.39058C5.25147 2.55037 5.2072 2.70659 5.12661 2.84462C5.04602 2.98265 4.93173 3.09798 4.79444 3.17983C4.65491 3.25786 4.49786 3.29922 4.338 3.30004C4.17813 3.30086 4.02067 3.2611 3.88035 3.1845C3.68435 3.08066 3.5426 3.0235 3.40202 3.00483C3.09537 2.96451 2.78526 3.04759 2.53985 3.23583C2.35669 3.37758 2.22019 3.61266 1.94835 4.08341C1.67652 4.55416 1.54002 4.78925 1.51027 5.01966C1.49022 5.1716 1.50031 5.32599 1.53994 5.47402C1.57958 5.62205 1.64799 5.76083 1.74127 5.88241C1.8276 5.99441 1.94835 6.08833 2.1356 6.20617C2.41152 6.37942 2.58885 6.67458 2.58885 7.00008C2.58885 7.32558 2.41152 7.62075 2.1356 7.79341C1.94835 7.91183 1.82702 8.00575 1.74127 8.11775C1.64799 8.23934 1.57958 8.37811 1.53994 8.52614C1.50031 8.67418 1.49022 8.82857 1.51027 8.9805C1.5406 9.21033 1.67652 9.446 1.94777 9.91675C2.22019 10.3875 2.3561 10.6226 2.53985 10.7643C2.66144 10.8576 2.80021 10.926 2.94825 10.9657C3.09628 11.0053 3.25067 11.0154 3.4026 10.9953C3.5426 10.9767 3.68435 10.9195 3.88035 10.8157C4.02067 10.7391 4.17813 10.6993 4.338 10.7001C4.49786 10.7009 4.65491 10.7423 4.79444 10.8203C5.07619 10.9837 5.2436 11.2841 5.25527 11.6096C5.26344 11.8312 5.28444 11.9829 5.33869 12.113C5.39732 12.2546 5.48329 12.3833 5.59169 12.4917C5.70009 12.6001 5.82879 12.6861 5.97044 12.7447C6.18452 12.8334 6.45635 12.8334 7.00002 12.8334C7.54369 12.8334 7.81552 12.8334 8.0296 12.7447C8.17125 12.6861 8.29995 12.6001 8.40835 12.4917C8.51675 12.3833 8.60272 12.2546 8.66135 12.113C8.71502 11.9829 8.7366 11.8312 8.74477 11.6096C8.75644 11.2841 8.92385 10.9831 9.2056 10.8203C9.34513 10.7423 9.50218 10.7009 9.66204 10.7001C9.82191 10.6993 9.97937 10.7391 10.1197 10.8157C10.3157 10.9195 10.4574 10.9767 10.5974 10.9953C10.7494 11.0154 10.9038 11.0053 11.0518 10.9657C11.1998 10.926 11.3386 10.8576 11.4602 10.7643C11.6439 10.6232 11.7799 10.3875 12.0517 9.91675C12.3235 9.446 12.46 9.21092 12.4898 8.9805C12.5098 8.82857 12.4997 8.67418 12.4601 8.52614C12.4205 8.37811 12.352 8.23934 12.2588 8.11775C12.1724 8.00575 12.0517 7.91183 11.8644 7.794C11.7279 7.71081 11.6147 7.59435 11.5354 7.4555C11.4561 7.31664 11.4134 7.15995 11.4112 7.00008C11.4112 6.67458 11.5885 6.37942 11.8644 6.20675C12.0517 6.08833 12.173 5.99441 12.2588 5.88241C12.352 5.76083 12.4205 5.62205 12.4601 5.47402C12.4997 5.32599 12.5098 5.1716 12.4898 5.01966C12.4594 4.78983 12.3235 4.55416 12.0523 4.08341C11.7799 3.61266 11.6439 3.37758 11.4602 3.23583C11.3386 3.14255 11.1998 3.07414 11.0518 3.0345C10.9038 2.99487 10.7494 2.98479 10.5974 3.00483C10.4574 3.0235 10.3157 3.08066 10.1191 3.1845C9.97886 3.261 9.8215 3.3007 9.66175 3.29988C9.502 3.29906 9.34506 3.25776 9.2056 3.17983C9.06831 3.09798 8.95402 2.98265 8.87343 2.84462C8.79283 2.70659 8.74857 2.55037 8.74477 2.39058C8.7366 2.16891 8.7156 2.01725 8.66135 1.88716C8.60272 1.74552 8.51675 1.61682 8.40835 1.50842C8.29995 1.40002 8.17125 1.31405 8.0296 1.25541Z"
        stroke="white"
      />
    </svg>
  ),

  cancelIconWhite: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
    >
      <path
        d="M2.55078 2.30005L8.55078 8.30005"
        stroke="white"
        stroke-linecap="round"
      />
      <path
        d="M8.55078 2.30005L2.55078 8.30005"
        stroke="white"
        stroke-linecap="round"
      />
    </svg>
  ),
  tickIconWhite: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
    >
      <path
        d="M8.54945 3.13636L4.18581 7.5L2.54945 5.86364"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  downloadIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
    >
      <path
        d="M7.39941 8.75V1.75M12.6494 8.75V11.0833C12.6494 11.3928 12.5265 11.6895 12.3077 11.9083C12.0889 12.1271 11.7922 12.25 11.4827 12.25H3.31608C3.00666 12.25 2.70992 12.1271 2.49112 11.9083C2.27233 11.6895 2.14941 11.3928 2.14941 11.0833V8.75"
        stroke="#101010"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.48242 5.83301L7.39909 8.74967L10.3158 5.83301"
        stroke="#101010"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),

  trendingIcon: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_853_7334)">
        <circle cx="16.0417" cy="15.0417" r="15.0417" fill="#FF8206" />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.9994 12C17.7342 12 17.4799 11.8946 17.2923 11.7071C17.1048 11.5196 16.9994 11.2652 16.9994 11C16.9994 10.7348 17.1048 10.4804 17.2923 10.2929C17.4799 10.1054 17.7342 10 17.9994 10H22.9994C23.2646 10 23.519 10.1054 23.7065 10.2929C23.8941 10.4804 23.9994 10.7348 23.9994 11V16C23.9994 16.2652 23.8941 16.5196 23.7065 16.7071C23.519 16.8946 23.2646 17 22.9994 17C22.7342 17 22.4799 16.8946 22.2923 16.7071C22.1048 16.5196 21.9994 16.2652 21.9994 16V13.414L17.7064 17.707C17.5189 17.8945 17.2646 17.9998 16.9994 17.9998C16.7343 17.9998 16.48 17.8945 16.2924 17.707L13.9994 15.414L9.70643 19.707C9.51783 19.8892 9.26523 19.99 9.00303 19.9877C8.74083 19.9854 8.49002 19.8802 8.30461 19.6948C8.1192 19.5094 8.01403 19.2586 8.01176 18.9964C8.00948 18.7342 8.11027 18.4816 8.29243 18.293L13.2924 13.293C13.48 13.1055 13.7343 13.0002 13.9994 13.0002C14.2646 13.0002 14.5189 13.1055 14.7064 13.293L16.9994 15.586L20.5854 12H17.9994Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_853_7334"
          x="0.115196"
          y="0"
          width="31.8536"
          height="31.8526"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.884804" />
          <feGaussianBlur stdDeviation="0.442402" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_853_7334"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_853_7334"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),

  pIcon: (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5527 8.13037C12.2875 8.13037 12.0332 8.23573 11.8456 8.42326C11.6581 8.6108 11.5527 8.86515 11.5527 9.13037C11.5527 9.39559 11.6581 9.64994 11.8456 9.83748C12.0332 10.025 12.2875 10.1304 12.5527 10.1304H16.5527C16.818 10.1304 17.0723 10.025 17.2598 9.83748C17.4474 9.64994 17.5527 9.39559 17.5527 9.13037C17.5527 8.86515 17.4474 8.6108 17.2598 8.42326C17.0723 8.23573 16.818 8.13037 16.5527 8.13037H12.5527ZM12.5527 17.1304C12.2875 17.1304 12.0332 17.2357 11.8456 17.4233C11.6581 17.6108 11.5527 17.8652 11.5527 18.1304C11.5527 18.3956 11.6581 18.6499 11.8456 18.8375C12.0332 19.025 12.2875 19.1304 12.5527 19.1304H16.5527C16.818 19.1304 17.0723 19.025 17.2598 18.8375C17.4474 18.6499 17.5527 18.3956 17.5527 18.1304C17.5527 17.8652 17.4474 17.6108 17.2598 17.4233C17.0723 17.2357 16.818 17.1304 16.5527 17.1304H12.5527Z"
        fill="white"
        fill-opacity="0.5"
      />
      <path
        d="M12.5527 5.13037C12.2875 5.13037 12.0332 5.23573 11.8456 5.42326C11.6581 5.6108 11.5527 5.86515 11.5527 6.13037C11.5527 6.39559 11.6581 6.64994 11.8456 6.83748C12.0332 7.02501 12.2875 7.13037 12.5527 7.13037H20.5527C20.818 7.13037 21.0723 7.02501 21.2598 6.83748C21.4474 6.64994 21.5527 6.39559 21.5527 6.13037C21.5527 5.86515 21.4474 5.6108 21.2598 5.42326C21.0723 5.23573 20.818 5.13037 20.5527 5.13037H12.5527ZM12.5527 14.1304C12.2875 14.1304 12.0332 14.2357 11.8456 14.4233C11.6581 14.6108 11.5527 14.8652 11.5527 15.1304C11.5527 15.3956 11.6581 15.6499 11.8456 15.8375C12.0332 16.025 12.2875 16.1304 12.5527 16.1304H20.5527C20.818 16.1304 21.0723 16.025 21.2598 15.8375C21.4474 15.6499 21.5527 15.3956 21.5527 15.1304C21.5527 14.8652 21.4474 14.6108 21.2598 14.4233C21.0723 14.2357 20.818 14.1304 20.5527 14.1304H12.5527Z"
        fill="white"
        fill-opacity="0.8"
      />
      <path
        d="M3.44922 4.13232C3.184 4.13232 2.92965 4.23768 2.74211 4.42522C2.55458 4.61275 2.44922 4.86711 2.44922 5.13232V10.1323C2.44922 10.3975 2.55458 10.6519 2.74211 10.8394C2.92965 11.027 3.184 11.1323 3.44922 11.1323H8.44922C8.71444 11.1323 8.96879 11.027 9.15633 10.8394C9.34386 10.6519 9.44922 10.3975 9.44922 10.1323V5.13232C9.44922 4.86711 9.34386 4.61275 9.15633 4.42522C8.96879 4.23768 8.71444 4.13232 8.44922 4.13232H3.44922ZM3.44922 13.1283C3.184 13.1283 2.92965 13.2337 2.74211 13.4212C2.55458 13.6088 2.44922 13.8631 2.44922 14.1283V19.1283C2.44922 19.3935 2.55458 19.6479 2.74211 19.8354C2.92965 20.023 3.184 20.1283 3.44922 20.1283H8.44922C8.71444 20.1283 8.96879 20.023 9.15633 19.8354C9.34386 19.6479 9.44922 19.3935 9.44922 19.1283V14.1283C9.44922 13.8631 9.34386 13.6088 9.15633 13.4212C8.96879 13.2337 8.71444 13.1283 8.44922 13.1283H3.44922Z"
        fill="white"
      />
    </svg>
  ),
  userIcon: (
    <svg
      width="60"
      height="60"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
        fill="#FF8206"
        fill-opacity="0.1"
      />
      <path
        d="M25.8327 27.5V25.8333C25.8327 24.9493 25.4815 24.1014 24.8564 23.4763C24.2313 22.8512 23.3834 22.5 22.4993 22.5H17.4993C16.6153 22.5 15.7674 22.8512 15.1423 23.4763C14.5172 24.1014 14.166 24.9493 14.166 25.8333V27.5"
        stroke="#FF8206"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.9993 19.1667C21.8403 19.1667 23.3327 17.6743 23.3327 15.8333C23.3327 13.9924 21.8403 12.5 19.9993 12.5C18.1584 12.5 16.666 13.9924 16.666 15.8333C16.666 17.6743 18.1584 19.1667 19.9993 19.1667Z"
        stroke="#FF8206"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  emailIcon: (
    <svg
      width="60"
      height="60"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
        fill="#FF8206"
        fill-opacity="0.1"
      />
      <path
        d="M26.6673 16.6665L20.6733 20.4845C20.4699 20.6026 20.2389 20.6649 20.0037 20.6649C19.7684 20.6649 19.5374 20.6026 19.334 20.4845L13.334 16.6665"
        stroke="#FF8206"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M25.334 14.6665H14.6673C13.9309 14.6665 13.334 15.2635 13.334 15.9998V23.9998C13.334 24.7362 13.9309 25.3332 14.6673 25.3332H25.334C26.0704 25.3332 26.6673 24.7362 26.6673 23.9998V15.9998C26.6673 15.2635 26.0704 14.6665 25.334 14.6665Z"
        stroke="#FF8206"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  logoutIcon: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.666 11.3332L13.9993 7.99984L10.666 4.6665" stroke="#D4183D" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M14 8H6" stroke="#D4183D" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M6 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H6" stroke="#D4183D" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  ),
  securityIcon: (
    <svg width="60" height="60" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z" fill="#FF8206" fill-opacity="0.1" />
      <path d="M25.8333 19.1665H14.1667C13.2462 19.1665 12.5 19.9127 12.5 20.8332V26.6665C12.5 27.587 13.2462 28.3332 14.1667 28.3332H25.8333C26.7538 28.3332 27.5 27.587 27.5 26.6665V20.8332C27.5 19.9127 26.7538 19.1665 25.8333 19.1665Z" stroke="#FF8206" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M15.834 19.1665V15.8332C15.834 14.7281 16.273 13.6683 17.0544 12.8869C17.8358 12.1055 18.8956 11.6665 20.0007 11.6665C21.1057 11.6665 22.1655 12.1055 22.9469 12.8869C23.7283 13.6683 24.1673 14.7281 24.1673 15.8332V19.1665" stroke="#FF8206" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  ),
  shieldIcon: (
    <svg width="60" height="60" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z" fill="#FF8206" fill-opacity="0.1" />
      <path d="M25.3327 20.6666C25.3327 24 22.9993 25.6666 20.226 26.6333C20.0808 26.6825 19.923 26.6802 19.7793 26.6266C16.9993 25.6666 14.666 24 14.666 20.6666V16C14.666 15.8232 14.7363 15.6536 14.8613 15.5286C14.9863 15.4035 15.1559 15.3333 15.3327 15.3333C16.666 15.3333 18.3327 14.5333 19.4927 13.52C19.6339 13.3993 19.8136 13.333 19.9993 13.333C20.1851 13.333 20.3648 13.3993 20.506 13.52C21.6727 14.54 23.3327 15.3333 24.666 15.3333C24.8428 15.3333 25.0124 15.4035 25.1374 15.5286C25.2624 15.6536 25.3327 15.8232 25.3327 16V20.6666Z" stroke="#FF8206" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  ),
  OrangeEditIcon: (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.4486 3.87476C13.8011 3.52237 13.9992 3.0444 13.9992 2.54599C13.9993 2.04758 13.8014 1.56956 13.449 1.21709C13.0966 0.864619 12.6186 0.666566 12.1202 0.666504C11.6218 0.666441 11.1438 0.864374 10.7913 1.21676L1.89397 10.1161C1.73918 10.2704 1.62471 10.4604 1.56064 10.6694L0.679972 13.5708C0.662742 13.6284 0.661441 13.6897 0.676206 13.748C0.690971 13.8063 0.721252 13.8596 0.763836 13.9021C0.80642 13.9446 0.859719 13.9748 0.918078 13.9895C0.976436 14.0041 1.03768 14.0027 1.09531 13.9854L3.99731 13.1054C4.20608 13.0419 4.39609 12.9282 4.55064 12.7741L13.4486 3.87476Z" stroke="#FF8206" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  ),
  saveIcon: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.1333 2C10.485 2.00501 10.8205 2.14878 11.0667 2.4L13.6 4.93333C13.8512 5.17951 13.995 5.51497 14 5.86667V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H10.1333Z" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M11.3327 13.9998V9.33317C11.3327 9.15636 11.2624 8.98679 11.1374 8.86177C11.0124 8.73674 10.8428 8.6665 10.666 8.6665H5.33268C5.15587 8.6665 4.9863 8.73674 4.86128 8.86177C4.73625 8.98679 4.66602 9.15636 4.66602 9.33317V13.9998" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M4.66602 2V4.66667C4.66602 4.84348 4.73625 5.01305 4.86128 5.13807C4.9863 5.2631 5.15587 5.33333 5.33268 5.33333H9.99935" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  ),
  lockIcon: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.6667 7.3335H3.33333C2.59695 7.3335 2 7.93045 2 8.66683V13.3335C2 14.0699 2.59695 14.6668 3.33333 14.6668H12.6667C13.403 14.6668 14 14.0699 14 13.3335V8.66683C14 7.93045 13.403 7.3335 12.6667 7.3335Z" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M4.66602 7.3335V4.66683C4.66602 3.78277 5.01721 2.93493 5.64233 2.30981C6.26745 1.68469 7.11529 1.3335 7.99935 1.3335C8.8834 1.3335 9.73125 1.68469 10.3564 2.30981C10.9815 2.93493 11.3327 3.78277 11.3327 4.66683V7.3335" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  ),
  greycancelIcon: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1728_5990)">
        <rect width="32" height="32" rx="16" fill="black" fill-opacity="0.1" />
        <path d="M21 11L11 21" stroke="white" stroke-width="1.11111" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M21 21L11 11" stroke="white" stroke-width="1.11111" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_1728_5990">
          <rect width="32" height="32" rx="16" fill="white" />
        </clipPath>
      </defs>
    </svg>

  ),
  likeIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.25 9.78613C21.0262 9.77647 20.8338 9.94477 20.8145 10.168L19.8193 21.6787C19.7732 22.2141 20.1955 22.6748 20.7334 22.6748C21.2399 22.6746 21.6502 22.264 21.6504 21.7578V10.2031C21.6501 9.97942 21.4735 9.79593 21.25 9.78613ZM12.5273 1.52734C12.1142 1.32827 11.6372 1.29523 11.2002 1.43555L11.0518 1.4834C10.3655 1.70388 9.83451 2.25063 9.65527 2.94141C9.46947 3.65783 9.43606 4.40529 9.55566 5.13574L10.2344 9.2793C10.2783 9.54676 10.0712 9.78512 9.80566 9.78516H4.49805C3.17985 9.78516 2.18071 10.9743 2.40527 12.2734L3.12793 16.4531C3.75085 20.0543 6.97761 22.6747 10.7363 22.6748H15.499C16.6012 22.6746 17.5193 21.8307 17.6143 20.7324L18.4463 11.1104C18.5051 10.4298 18.2332 9.76226 17.7158 9.31641L16.2422 8.0459C15.5655 7.46279 14.9583 6.86708 14.5713 6.14258C14.2956 5.62637 14.0812 5.08009 13.9346 4.51465L13.4473 2.63672C13.3211 2.15026 12.9826 1.74678 12.5273 1.52734Z" fill="#FF8206" stroke="#FFCD9D" stroke-width="0.7" />
    </svg>

  ),
  happyIcon: (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 14C6.66667 15.2857 8.1 16.5 10.5 16.5C12.9 16.5 14.3333 15.2857 15 14M20.5 10.5C20.5 4.9772 16.0228 0.5 10.5 0.5C4.97715 0.5 0.5 4.9772 0.5 10.5C0.5 16.0229 4.97715 20.5 10.5 20.5C16.0228 20.5 20.5 16.0229 20.5 10.5Z" fill="#FF8206" />
      <path d="M6 14C6.66667 15.2857 8.1 16.5 10.5 16.5C12.9 16.5 14.3333 15.2857 15 14M20.5 10.5C20.5 4.9772 16.0228 0.5 10.5 0.5C4.97715 0.5 0.5 4.9772 0.5 10.5C0.5 16.0229 4.97715 20.5 10.5 20.5C16.0228 20.5 20.5 16.0229 20.5 10.5Z" stroke="#FFCD9D" stroke-linecap="round" />
      <path d="M7.5 6C7.77614 6 8 6.22386 8 6.5C8 6.77614 7.77614 7 7.5 7C7.22386 7 7 6.77614 7 6.5C7 6.22386 7.22386 6 7.5 6Z" fill="#FF8206" stroke="#FFCD9D" />
      <path d="M13.5 6C13.7762 6 14 6.22386 14 6.5C14 6.77614 13.7762 7 13.5 7C13.2238 7 13 6.77614 13 6.5C13 6.22386 13.2238 6 13.5 6Z" fill="#FF8206" stroke="#FFCD9D" />
    </svg>
  ),
  supportIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M15.5829 1.58206C16.8949 2.0236 17.75 3.25813 17.75 4.87666C17.75 5.8942 17.1715 6.83077 16.5269 7.57799C15.8643 8.34611 15.0256 9.03541 14.292 9.57017C14.2606 9.59308 14.2294 9.61586 14.1985 9.63846C13.4865 10.1587 12.8991 10.5879 12 10.5879C11.1008 10.5879 10.5134 10.1587 9.80148 9.63845C9.77055 9.61585 9.73938 9.59307 9.70794 9.57016C8.97435 9.0354 8.13569 8.3461 7.47305 7.57798C6.82845 6.83076 6.25 5.8942 6.25 4.87667C6.25 3.25814 7.10502 2.02361 8.41707 1.58207C9.53614 1.20546 10.8387 1.45404 12 2.29934C13.1612 1.45404 14.4638 1.20546 15.5829 1.58206Z" fill="#FF8206" stroke="#FFCD9D" stroke-width="0.7" />
      <path d="M7.25993 20.3884H5V16.2429C7.62942 14.3782 11.9817 13.1074 14.7791 14.7759C14.9475 14.8764 15.0991 14.9977 15.2285 15.1431C15.4359 15.4158 15.4849 15.7719 15.4964 16.1478C15.5036 16.3794 15.4466 16.6081 15.3439 16.8158C15.2083 17.0901 15.4379 17.3898 15.7252 17.2845C16.3385 17.0597 16.8852 16.6953 17.3974 16.3084L19.2046 14.9433C19.8417 14.462 20.7873 14.4619 21.4245 14.943C21.9982 15.3762 22.1736 16.0894 21.8109 16.6707C21.388 17.3487 20.7921 18.216 20.2199 18.7459C19.6469 19.2766 18.7939 19.7504 18.0975 20.0865C17.326 20.4589 16.4738 20.6734 15.6069 20.8138C13.8488 21.0983 12.0166 21.0549 10.2763 20.6964C9.29253 20.4937 8.27079 20.3884 7.25993 20.3884Z" fill="#FF8206" stroke="#FFCD9D" stroke-width="0.7" stroke-linecap="round" />
      <path d="M5 15.5C5 14.6716 4.32843 14 3.5 14C2.67157 14 2 14.6716 2 15.5V20.5C2 21.3284 2.67157 22 3.5 22C4.32843 22 5 21.3284 5 20.5V15.5Z" fill="#FF8206" stroke="#FFCD9D" stroke-width="0.7" />
    </svg>
  ),
  hurtIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 17C7.66667 15.7143 9.6 14 12 14C14.4 14 16.3333 15.7143 17 17M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" fill="#FF8206" />
      <path d="M7 17C7.66667 15.7143 9.6 14 12 14C14.4 14 16.3333 15.7143 17 17M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#FFCD9D" stroke-linecap="round" />
      <path d="M10 8C10 8.55228 9.55228 9 9 9C8.44772 9 8 8.55228 8 8C8 7.44772 8.44772 7 9 7C9.55228 7 10 7.44772 10 8Z" fill="#FFCD9D" />
      <path d="M16 8C16 8.55228 15.5523 9 15 9C14.4477 9 14 8.55228 14 8C14 7.44772 14.4477 7 15 7C15.5523 7 16 7.44772 16 8Z" fill="#FFCD9D" />
    </svg>

  ),
  bookletIcon: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5007 1.66699H5.00065C4.55862 1.66699 4.1347 1.84259 3.82214 2.15515C3.50958 2.46771 3.33398 2.89163 3.33398 3.33366V16.667C3.33398 17.109 3.50958 17.5329 3.82214 17.8455C4.1347 18.1581 4.55862 18.3337 5.00065 18.3337H15.0007C15.4427 18.3337 15.8666 18.1581 16.1792 17.8455C16.4917 17.5329 16.6673 17.109 16.6673 16.667V5.83366L12.5007 1.66699Z" stroke="#FF8206" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M11.666 1.66699V5.00033C11.666 5.44235 11.8416 5.86628 12.1542 6.17884C12.4667 6.4914 12.8907 6.66699 13.3327 6.66699H16.666" stroke="#FF8206" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M8.33268 7.5H6.66602" stroke="#FF8206" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M13.3327 10.833H6.66602" stroke="#FF8206" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M13.3327 14.167H6.66602" stroke="#FF8206" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  ),
  exportIcon: (
    <svg width="12" height="17" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.5 6.5L6 3L9.5 6.5" stroke="#4DB847" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M6 13.5V6.5" stroke="#4DB847" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  ),
  downwardIcon: (
    <svg width="12" height="17" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.5 10L6 13.5L9.5 10" stroke="#EE3722" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M6 3V10" stroke="#EE3722" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  ),
  rightslidIcon: (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z" fill="white" fill-opacity="0.2" />
      <path d="M27 30L21 24L27 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  ),
  leftslideIcon: (<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z" fill="white" fill-opacity="0.2" />
    <path d="M21 30L27 24L21 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
  ), facebookIcon: (<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="20" fill="#003366" />
    <path d="M23.2539 20.625H21.2031V26.75H18.4688V20.625H16.2266V18.1094H18.4688V16.168C18.4688 13.9805 19.7812 12.75 21.7773 12.75C22.7344 12.75 23.7461 12.9414 23.7461 12.9414V15.1016H22.625C21.5312 15.1016 21.2031 15.7578 21.2031 16.4688V18.1094H23.6367L23.2539 20.625Z" fill="white" />
  </svg>
  ),
  twitterIcon: (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="20" fill="#003366" />

      <g mask="url(#mask0_11100_63797)">
        <path d="M21.3696 18.9011L26.7243 12.8105H25.4556L20.804 18.0978L17.0915 12.8105H12.8086L18.4239 20.8065L12.8086 27.1928H14.0773L18.9865 21.608L22.908 27.1928H27.1909L21.3696 18.9011ZM19.6314 20.8767L19.0616 20.08L14.5349 13.7464H16.4839L20.1381 18.8597L20.7055 19.6564L25.455 26.3025H23.5059L19.6314 20.8767Z" fill="white" />
      </g>
    </svg>
  ),
  instaIcon: (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="20" fill="#003366" />
      <path d="M19.9994 16.0078C22.4604 16.0078 24.4916 18.0391 24.4916 20.5C24.4916 23 22.4604 24.9922 19.9994 24.9922C17.4994 24.9922 15.5073 23 15.5073 20.5C15.5073 18.0391 17.4994 16.0078 19.9994 16.0078ZM19.9994 23.4297C21.601 23.4297 22.8901 22.1406 22.8901 20.5C22.8901 18.8984 21.601 17.6094 19.9994 17.6094C18.3588 17.6094 17.0698 18.8984 17.0698 20.5C17.0698 22.1406 18.3979 23.4297 19.9994 23.4297ZM25.7026 15.8516C25.7026 16.4375 25.2338 16.9062 24.6479 16.9062C24.0619 16.9062 23.5932 16.4375 23.5932 15.8516C23.5932 15.2656 24.0619 14.7969 24.6479 14.7969C25.2338 14.7969 25.7026 15.2656 25.7026 15.8516ZM28.6713 16.9062C28.7494 18.3516 28.7494 22.6875 28.6713 24.1328C28.5932 25.5391 28.2807 26.75 27.2651 27.8047C26.2494 28.8203 24.9994 29.1328 23.5932 29.2109C22.1479 29.2891 17.8119 29.2891 16.3666 29.2109C14.9604 29.1328 13.7494 28.8203 12.6948 27.8047C11.6791 26.75 11.3666 25.5391 11.2885 24.1328C11.2104 22.6875 11.2104 18.3516 11.2885 16.9062C11.3666 15.5 11.6791 14.25 12.6948 13.2344C13.7494 12.2188 14.9604 11.9062 16.3666 11.8281C17.8119 11.75 22.1479 11.75 23.5932 11.8281C24.9994 11.9062 26.2494 12.2188 27.2651 13.2344C28.2807 14.25 28.5932 15.5 28.6713 16.9062ZM26.7963 25.6562C27.2651 24.5234 27.1479 21.7891 27.1479 20.5C27.1479 19.25 27.2651 16.5156 26.7963 15.3438C26.4838 14.6016 25.8979 13.9766 25.1557 13.7031C23.9838 13.2344 21.2494 13.3516 19.9994 13.3516C18.7104 13.3516 15.976 13.2344 14.8432 13.7031C14.0619 14.0156 13.476 14.6016 13.1635 15.3438C12.6948 16.5156 12.8119 19.25 12.8119 20.5C12.8119 21.7891 12.6948 24.5234 13.1635 25.6562C13.476 26.4375 14.0619 27.0234 14.8432 27.3359C15.976 27.8047 18.7104 27.6875 19.9994 27.6875C21.2494 27.6875 23.9838 27.8047 25.1557 27.3359C25.8979 27.0234 26.5229 26.4375 26.7963 25.6562Z" fill="white" />
    </svg>
  ),
  youtubeIcon: (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="20" fill="#003366" />
      <path d="M30.1964 15.3828C30.6652 17.0234 30.6652 20.5391 30.6652 20.5391C30.6652 20.5391 30.6652 24.0156 30.1964 25.6953C29.9621 26.6328 29.2199 27.3359 28.3214 27.5703C26.6417 28 20.0011 28 20.0011 28C20.0011 28 13.3214 28 11.6417 27.5703C10.7433 27.3359 10.0011 26.6328 9.76674 25.6953C9.29799 24.0156 9.29799 20.5391 9.29799 20.5391C9.29799 20.5391 9.29799 17.0234 9.76674 15.3828C10.0011 14.4453 10.7433 13.7031 11.6417 13.4688C13.3214 13 20.0011 13 20.0011 13C20.0011 13 26.6417 13 28.3214 13.4688C29.2199 13.7031 29.9621 14.4453 30.1964 15.3828ZM17.8136 23.7031L23.3605 20.5391L17.8136 17.375V23.7031Z" fill="white" />
    </svg>
  ),
  wIcon: (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="20" fill="#003366" />
      <path d="M26.0932 14.3281C27.7338 15.9688 28.7494 18.1172 28.7494 20.4609C28.7494 25.2266 24.7651 29.1328 19.9604 29.1328C18.5151 29.1328 17.1088 28.7422 15.8198 28.0781L11.2494 29.25L12.4604 24.7578C11.7182 23.4688 11.2885 21.9844 11.2885 20.4219C11.2885 15.6562 15.1948 11.75 19.9604 11.75C22.3041 11.75 24.4916 12.6875 26.0932 14.3281ZM19.9604 27.6484C23.9448 27.6484 27.2651 24.4062 27.2651 20.4609C27.2651 18.5078 26.4448 16.7109 25.0776 15.3438C23.7104 13.9766 21.9135 13.2344 19.9994 13.2344C16.0151 13.2344 12.7729 16.4766 12.7729 20.4219C12.7729 21.7891 13.1635 23.1172 13.8666 24.2891L14.0619 24.5625L13.3198 27.2188L16.0541 26.4766L16.2885 26.6328C17.4213 27.2969 18.6713 27.6484 19.9604 27.6484ZM23.9448 22.2578C24.1401 22.375 24.2963 22.4141 24.3354 22.5312C24.4135 22.6094 24.4135 23.0391 24.2182 23.5469C24.0229 24.0547 23.1635 24.5234 22.7729 24.5625C22.0698 24.6797 21.5229 24.6406 20.1557 24.0156C17.9682 23.0781 16.5619 20.8906 16.4448 20.7734C16.3276 20.6172 15.5854 19.6016 15.5854 18.5078C15.5854 17.4531 16.1323 16.9453 16.3276 16.7109C16.5229 16.4766 16.7573 16.4375 16.9135 16.4375C17.0307 16.4375 17.1869 16.4375 17.3041 16.4375C17.4604 16.4375 17.6166 16.3984 17.8119 16.8281C17.9682 17.2578 18.4369 18.3125 18.476 18.4297C18.5151 18.5469 18.5541 18.6641 18.476 18.8203C18.0854 19.6406 17.6166 19.6016 17.851 19.9922C18.7104 21.4375 19.5307 21.9453 20.8198 22.5703C21.0151 22.6875 21.1323 22.6484 21.2885 22.5312C21.4057 22.375 21.8354 21.8672 21.9526 21.6719C22.1088 21.4375 22.2651 21.4766 22.4604 21.5547C22.6557 21.6328 23.7104 22.1406 23.9448 22.2578Z" fill="white" />
    </svg>
  ),
  callIcon: (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22.6377 26.8146C22.4097 27.2979 21.9291 27.594 21.4213 27.5044C9.55746 25.4125 1.69482 14.1257 3.77859 2.30803C3.87627 1.75408 4.27267 1.39559 4.80488 1.34664L9.80117 1.08526C10.3252 1.08248 10.8385 1.41097 10.9798 1.95946L12.2839 7.52041C12.3872 8.01459 12.1592 8.49797 11.7329 8.75599L8.50996 10.5676C9.58309 14.4695 12.0247 17.8987 15.2401 20.1792L18.0447 17.7702C18.433 17.4579 18.9652 17.4089 19.3943 17.675L24.1738 20.8025C24.6409 21.1228 24.8202 21.7256 24.5922 22.209L22.6377 26.8146Z" fill="#003366" />
    </svg>
  ),
  emailIcon: (<svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.75 0C22.9688 0 24 1.03125 24 2.25V15.75C24 17.0156 22.9688 18 21.75 18H2.25C0.984375 18 0 17.0156 0 15.75V2.25C0 1.03125 0.984375 0 2.25 0H21.75ZM21.75 2.25H2.25V4.17188C3.28125 5.0625 4.96875 6.375 8.53125 9.1875C9.32812 9.79688 10.875 11.2969 12 11.25C13.0781 11.2969 14.625 9.79688 15.4219 9.1875C18.9844 6.375 20.6719 5.0625 21.75 4.17188V2.25ZM2.25 15.75H21.75V7.07812C20.6719 7.92188 19.125 9.14062 16.8281 10.9688C15.75 11.7656 13.9688 13.5469 12 13.5C9.98438 13.5469 8.15625 11.7656 7.125 10.9688C4.82812 9.14062 3.28125 7.92188 2.25 7.07812V15.75Z" fill="#003366" />
  </svg>
  ),
  mesIcon: (
    <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.75 0C22.9688 0 24 1.03125 24 2.25V15.75C24 17.0156 22.9688 18 21.75 18H2.25C0.984375 18 0 17.0156 0 15.75V2.25C0 1.03125 0.984375 0 2.25 0H21.75ZM21.75 2.25H2.25V4.17188C3.28125 5.0625 4.96875 6.375 8.53125 9.1875C9.32812 9.79688 10.875 11.2969 12 11.25C13.0781 11.2969 14.625 9.79688 15.4219 9.1875C18.9844 6.375 20.6719 5.0625 21.75 4.17188V2.25ZM2.25 15.75H21.75V7.07812C20.6719 7.92188 19.125 9.14062 16.8281 10.9688C15.75 11.7656 13.9688 13.5469 12 13.5C9.98438 13.5469 8.15625 11.7656 7.125 10.9688C4.82812 9.14062 3.28125 7.92188 2.25 7.07812V15.75Z" fill="#003366" />
    </svg>

  ),
  blocation: (
    <svg width="18" height="25" viewBox="0 0 18 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.0625 23.5312C1.21875 13.6875 0 12.6562 0 9C0 4.03125 3.98438 0 9 0C13.9688 0 18 4.03125 18 9C18 12.6562 16.7344 13.6875 9.89062 23.5312C9.46875 24.1875 8.48438 24.1875 8.0625 23.5312ZM9 12.75C11.0625 12.75 12.75 11.1094 12.75 9C12.75 6.9375 11.0625 5.25 9 5.25C6.89062 5.25 5.25 6.9375 5.25 9C5.25 11.1094 6.89062 12.75 9 12.75Z" fill="#003366" />
    </svg>
  ),
  callIcon: (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22.6377 26.8146C22.4097 27.2979 21.9291 27.594 21.4213 27.5044C9.55746 25.4125 1.69482 14.1257 3.77859 2.30803C3.87627 1.75408 4.27267 1.39559 4.80488 1.34664L9.80117 1.08526C10.3252 1.08248 10.8385 1.41097 10.9798 1.95946L12.2839 7.52041C12.3872 8.01459 12.1592 8.49797 11.7329 8.75599L8.50996 10.5676C9.58309 14.4695 12.0247 17.8987 15.2401 20.1792L18.0447 17.7702C18.433 17.4579 18.9652 17.4089 19.3943 17.675L24.1738 20.8025C24.6409 21.1228 24.8202 21.7256 24.5922 22.209L22.6377 26.8146Z" fill="#003366" />
    </svg>
  ),
  fbIconWhite: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.9987 1.66602H12.4987C11.3936 1.66602 10.3338 2.105 9.55242 2.8864C8.77102 3.66781 8.33203 4.72761 8.33203 5.83268V8.33268H5.83203V11.666H8.33203V18.3327H11.6654V11.666H14.1654L14.9987 8.33268H11.6654V5.83268C11.6654 5.61167 11.7532 5.39971 11.9094 5.24343C12.0657 5.08715 12.2777 4.99935 12.4987 4.99935H14.9987V1.66602Z" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  ),
  twitterIconWhite: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.3346 3.3327C18.3346 3.3327 17.7513 5.0827 16.668 6.16603C18.0013 14.4994 8.83464 20.5827 1.66797 15.8327C3.5013 15.916 5.33464 15.3327 6.66797 14.166C2.5013 12.916 0.417969 7.99937 2.5013 4.16603C4.33464 6.3327 7.16797 7.5827 10.0013 7.49937C9.2513 3.99937 13.3346 1.99937 15.8346 4.3327C16.7513 4.3327 18.3346 3.3327 18.3346 3.3327Z" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  ),
  instaIconWhite: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_11100_64476)">
        <path d="M14.168 1.66602H5.83464C3.53345 1.66602 1.66797 3.5315 1.66797 5.83268V14.166C1.66797 16.4672 3.53345 18.3327 5.83464 18.3327H14.168C16.4692 18.3327 18.3346 16.4672 18.3346 14.166V5.83268C18.3346 3.5315 16.4692 1.66602 14.168 1.66602Z" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M13.3337 9.47525C13.4366 10.1688 13.3181 10.8771 12.9952 11.4994C12.6723 12.1218 12.1614 12.6264 11.5351 12.9416C10.9088 13.2569 10.1991 13.3666 9.5069 13.2552C8.81468 13.1438 8.17521 12.817 7.67944 12.3212C7.18367 11.8255 6.85685 11.186 6.74546 10.4938C6.63408 9.80154 6.74379 9.09183 7.05901 8.46556C7.37423 7.8393 7.8789 7.32837 8.50123 7.00545C9.12356 6.68254 9.83187 6.56407 10.5254 6.66692C11.2328 6.77182 11.8878 7.10147 12.3935 7.60717C12.8992 8.11288 13.2288 8.76782 13.3337 9.47525Z" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M14.582 5.41602H14.5904" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_11100_64476">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  linkedInIconWhite: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.332 6.66602C14.6581 6.66602 15.9299 7.1928 16.8676 8.13048C17.8052 9.06816 18.332 10.3399 18.332 11.666V17.4993H14.9987V11.666C14.9987 11.224 14.8231 10.8001 14.5105 10.4875C14.198 10.1749 13.7741 9.99935 13.332 9.99935C12.89 9.99935 12.4661 10.1749 12.1535 10.4875C11.841 10.8001 11.6654 11.224 11.6654 11.666V17.4993H8.33203V11.666C8.33203 10.3399 8.85882 9.06816 9.7965 8.13048C10.7342 7.1928 12.0059 6.66602 13.332 6.66602Z" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M5.0013 7.5H1.66797V17.5H5.0013V7.5Z" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M3.33464 4.99935C4.25511 4.99935 5.0013 4.25316 5.0013 3.33268C5.0013 2.41221 4.25511 1.66602 3.33464 1.66602C2.41416 1.66602 1.66797 2.41221 1.66797 3.33268C1.66797 4.25316 2.41416 4.99935 3.33464 4.99935Z" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  ),
  hamIcon: (
    <svg width="26" height="19" viewBox="0 0 32 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_11239_5942)">
        <path d="M1.5 1.5H30.5" stroke="white" stroke-width="3" stroke-linecap="round" />
      </g>
      <g clip-path="url(#clip1_11239_5942)">
        <path d="M1.5 9.5H30.5" stroke="white" stroke-width="3" stroke-linecap="round" />
      </g>
      <g clip-path="url(#clip2_11239_5942)">
        <path d="M1.5 17.5H30.5" stroke="white" stroke-width="3" stroke-linecap="round" />
      </g>
      <defs>
        <clipPath id="clip0_11239_5942">
          <rect width="32" height="3" fill="white" />
        </clipPath>
        <clipPath id="clip1_11239_5942">
          <rect width="32" height="3" fill="white" transform="translate(0 8)" />
        </clipPath>
        <clipPath id="clip2_11239_5942">
          <rect width="32" height="3" fill="white" transform="translate(0 16)" />
        </clipPath>
      </defs>
    </svg>
  ),
  rightIcon: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 3.3335L10.6667 8.00017L6 12.6669" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  ),
  leftIcon: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 4.00195L6 8.00195L10 12.002" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  )
};

export default svg;
